/* tslint:disable */
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Rx";
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DatePipe, registerLocaleData } from '@angular/common';
import { GenProvider } from "../gen/gen";
import { ISubscription } from "rxjs/Subscription";
import { ValidaCampoProvider } from "../valida-campo/valida-campo";
import { CamelcasePipe } from "../../pipes/camelcase/camelcase"
//import { NgxQRCodeComponent, NgxQRCodeModule } from 'ngx-qrcode3';


declare var google;
@Injectable()
export class ServiceProvider {
  // @ViewChild('ngxQrCode') myQrCode : ElementRef;
  vcardData: string = "";
  public time: any;
  public time_resposta: number = 3; // minutos
  public url: any;
  public contatos = [];
  key: number = 0;
  intervalo: any;
  pergunta: any;
  bem_vindo = "";
  mensagem = "";
  pergunta_nome: any;
  isLog: boolean = false;
  lastNuber: any;
  isonLine: boolean = false;
  isPergunta: boolean = false;
  subscription: ISubscription;
  msgSubscription: ISubscription;
  url_pergunta_item: any;
  url_pergunta: any = 0;
  key_pergunta: any = 0;
  nivel = 0;
  key_child: any = 0;
  key_master: any = 0;
  uid: any = 0;
  msg_navegacao: any;
  menus: any;
  item: {};
  ctrl = "\n";
  //  ctrl = ''+String.fromCharCode(92, 110) +''
  // rodape: string ="Para alterar seu nome digite: **perfil*. "+this.ctrl+"digite: **sair* para não receber mais nossas mensagens";
  rodape: string =
    "👤 Para alterar seus dados de perfil digite: **perfil*. " + this.ctrl;
  parametros: any;
  isChatBot: any = false;
  saudacao: string;
  myTimer: any;
  continua: boolean;
  atendimento: any;
  escolha_opcao: any;
  departamento: any;
  classificado: any;
  anunciar: any;
  classificados: any;
  publicidade: any;
  publicidade_rodape: {};
  publicidade_tipo: any;
  localizacao: any;
  data_nascimento: any;
  cancelar_denuncia: any;
  enquete: any;
  menu_enquete: any[];
  enqueteOpcao: any;
  menuOpcao: any;
  menuEnqueteOpcao: any;
  imagemAnuncio: any;
  midiaMensagem: any;
  type_midia: any;
  galeria: any[];
  cancelar = this.ctrl + "Para cancelar, digite e envie apenas o número *_0_*";
  enqueteEncerrada: any;
  menu_enquete_encerrada: any[];
  postSubscription: any;
  isAcesso: number;
  pergunta_nome_midia: any;
  opcao_invalida_midia: any;
  bem_vindo_midia: any;
  isMonitora: any;
  autoPhone: any;
  menu_texto: any;
  menu_texto_ativo: any;
  mensagem_full: any;
  chatbot: any;
  atendimento_final: any;
  noticia: any[];
  bloqueado: any;
  cancela_mensagem: any;
  msg_denuncia: any;
  msg_mensagem: any;
  msg_recebida: any;
  primeiro_acesso_saudacao: any;
  natureza: any;
  msg_padrao_denuncia: any;
  invalida01_padrao_denuncia: any;
  invalida02_padrao_denuncia: any;
  invalida03_padrao_denuncia: any;
  msg_denuncia_acompanhar: any;
  sendSubscription: any;
  msg_sugestao: any;
  qtdOnline: number;
  informaProtocolo: any;
  denuncia: any[];
  denuncia_body: any[];
  mensagens: any[];
  mensagens_body: any[];
  ouvidoria: any[];
  ouvidoria_body: any[];
  setor: any[];
  setor_body: any[];
  mensagemCount: any;
  statusBot: boolean = false;
  isGravarPergunta: boolean = false;
  unSubstatus: any;
  subAbrir: any;
  getChatUpdate: any;
  ChatUpdate: any;
  msg_midia: any;
  tokenFace: any;
  userIdFace: any;
  finaliza_atendimento: any;
  acaobot: any;
  texto_acao: any;
  opcao_acao: any;
  type_bem_vindo_midia: any;
  ponto: any;
  chatLive: any;
  unSubChatLive: ISubscription;
  unSubPonto: ISubscription;
  dicas: any;
  constructor(
    public http: HttpClient,
    private genProvider: GenProvider,
    public validaCampoProvider: ValidaCampoProvider
  ) {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1",
      "method": "post"
    });
    let options = {
      headers: headers
    }
  }
  onLoadDepartamento() {
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/departamento",
        "numero",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.departamento = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      );
  }
  onLoadEnquete() {
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/enquete",
        "key_enquete",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.enquete = JSON.parse(JSON.stringify(data));
          this.onLoadEnqueteOpcao();
        },
        err => console.log(err)
      );
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/enquete",
        "key_enquete",
        "status",
        "encerrada"
      )
      .subscribe(
        data => {
          this.enqueteEncerrada = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      );
  }
  onLoadEnqueteOpcao() {
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/enquete_item",
        "numero",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.enqueteOpcao = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      );
  }
  onParametro() {
    this.parametros = this.genProvider.parametros;
    this.url_pergunta_item = "dados/" + this.parametros.path + "/item";
    this.url_pergunta = "dados/" + this.parametros.path + "/pergunta";
    this.url = this.parametros.servidor;
    this.time_resposta = this.genProvider.parametros.request;
    this.tokenFace = this.parametros.tokenFace;
    this.userIdFace = this.parametros.userIdFace;
    this.onLoadMenu();
  }
  onLoadChatbot() {
    this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/chatbot", "pergunta", "status", "ativo")
      .subscribe(
        data => {
          this.chatbot = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      );
  }
  onLoadNatureza() {
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/natureza",
        "pergunta",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.natureza = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      );
  }
  onLoadMenu() {
    // carrega opcoes de atendimento do bot
    this.genProvider
      .onGetfilter(this.url_pergunta, "status", "ativo")
      .subscribe(
        data => {
          let res = JSON.parse(JSON.stringify(data));
          if (res.length > 0) {
            this.onLoadItem(res[0].key_pergunta);
            this.pergunta = res[0];
            this.rodape = this.pergunta.rodape || "";
            this.key_pergunta = res[0].key_pergunta;
            this.msg_denuncia_acompanhar = res[0].msg_denuncia_acompanhar;
            this.informaProtocolo = res[0].protocolo;
            this.invalida01_padrao_denuncia = res[0].invalida01_padrao_denuncia;
            this.invalida02_padrao_denuncia = res[0].invalida02_padrao_denuncia;
            this.invalida03_padrao_denuncia = res[0].invalida03_padrao_denuncia;
            this.finaliza_atendimento = res[0].finaliza_atendimento,
              this.acaobot = res[0].acaobot,
              this.texto_acao = res[0].texto_acao,
              this.opcao_acao = res[0].opcao_acao
            this.msg_padrao_denuncia = res[0].msg_padrao_denuncia;
            this.msg_recebida = res[0].msg_recebida;
            this.msg_mensagem = res[0].msg_mensagem;
            this.msg_denuncia = res[0].msg_denuncia;
            this.msg_sugestao = res[0].msg_sugestao;
            this.msg_midia = res[0].msg_midia;
            this.menu_texto = res[0].menu_texto;
            this.menu_texto_ativo = res[0].menu_texto_ativo;
            this.msg_navegacao = res[0].msg_navegacao;
            this.mensagem = res[0].mensagem;
            this.localizacao = res[0].localizacao;
            this.data_nascimento = res[0].data_nascimento;
            this.anunciar = res[0].anunciar;
            this.atendimento = res[0].atendimento;
            this.escolha_opcao = res[0].escolha_opcao;
            this.atendimento_final = res[0].atendimento_final;
            this.cancelar_denuncia =
              "Para cancelar a denúncia, digite e envie apenas o número *_0_*";
            this.bem_vindo = this.pergunta.bem_vindo.replace(
              "{{1}}",
              this.parametros.razao
            );
            this.pergunta_nome = this.pergunta.pergunta_nome.replace(
              "{{1}}",
              this.parametros.razao
            );
            this.pergunta_nome_midia = res[0].pergunta_nome_midia;
            this.primeiro_acesso_saudacao = res[0].primeiro_acesso_saudacao;
            this.opcao_invalida_midia = res[0].opcao_invalida_midia;
            this.cancela_mensagem = res[0].cancela_mensagem;
            this.bem_vindo_midia = res[0].bem_vindo_midia;
            this.type_bem_vindo_midia = res[0].type_bem_vindo_midia
            this.isPergunta = true;
          } else {
            this.isPergunta = false;
          }
        },
        err => console.log(err)
      );
  }
  onConfig() {
    // configura e carrega todas as tabelas
    this.parametros = this.genProvider.parametros;
    this.onLoadDepartamento();
    this.onLoadEnquete();
    //  this.onPublicidade();
    this.onLoadChatbot();
    this.onLoadNatureza();
    this.onAtualizaUsuario();
    this.genProvider
      .remove("whatsPost", this.parametros.instancia)
      .then(() => { });
    this.genProvider
      .remove("dados/" + this.parametros.path + "/abrirdenuncia", this.parametros.instancia)
      .then(() => { });
    this.genProvider
      .remove("dados/" + this.parametros.path + "/srvComando", this.parametros.instancia)
      .then(() => { });

    let now = new Date();

    if (now.getHours() >= 0 && now.getHours() < 12) {
      this.saudacao = "Bom dia";
    } else if (now.getHours() >= 12 && now.getHours() < 18) {
      this.saudacao = "Boa tarde";
    } else {
      this.saudacao = "Boa noite";
    }
  }
  onAtualizaUsuario() {
    let unSub = this.genProvider
      .onGetfilter("dados/" + this.parametros.path + "/contato", "online", "on")
      .subscribe(data => {
        this.contatos = JSON.parse(JSON.stringify(data));
        unSub.unsubscribe();
        this.onAtualizaMensagens()
      });
  }
  onAtualizaMensagens() {
    this.denuncia = [];
    this.denuncia_body = [];
    this.mensagens = [];
    this.mensagens_body = [];
    this.ouvidoria = [];
    this.ouvidoria_body = [];
    this.setor = [];
    this.setor_body = [];
    let contatos = this.contatos;
    let unSubQtd = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/denuncia", "status", "Nova").subscribe(data => {
      unSubQtd.unsubscribe();
      let count = JSON.parse(JSON.stringify(data));
      this.mensagemCount = count.length
    });
    contatos.forEach(element => {
      // denuncias
      if (element.protocolo) {
        let unSubscribe = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/denuncia", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            delete dados["key"]
            this.denuncia.push(dados[0]);
            this.genProvider
              .onGetFilterOrder(
                "dados/" + this.parametros.path + "/denuncia_body",
                "time",
                "protocolo",
                element.protocolo
              )
              .subscribe(data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                //  console.log(dados_body)
                delete dados_body["key"]
                dados_body.forEach(res => {
                  this.denuncia_body.push(res);
                });
              });
          }
        });
        // mensagens
        let unSubscribe2 = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/mensagem", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe2.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.mensagens.push(dados[0]);
            this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/mensagem_body", "time", "protocolo", element.protocolo).subscribe(data_body => {
              let dados_body = JSON.parse(JSON.stringify(data_body));
              dados_body.forEach(res => {
                this.mensagens_body.push(res);
              });
            });
          }
        });
        // ouvidoria
        let unSubscribe3 = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/ouvidoria", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe3.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.ouvidoria.push(dados[0]);
            this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/ouvidoria_body", "time", "protocolo", element.protocolo).subscribe(data_body => {
              let dados_body = JSON.parse(JSON.stringify(data_body));
              dados_body.forEach(res => {
                this.ouvidoria_body.push(res);
              });
            });
          }
        });

        // setor
        let unSubscribe4 = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/setor", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe4.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.setor.push(dados[0]);
            this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/setor_body", "time", "protocolo", element.protocolo).subscribe(data_body => {
              let dados_body = JSON.parse(JSON.stringify(data_body));
              dados_body.forEach(res => {
                this.setor_body.push(res);
              });
            });
          }
        });
      }
    });
  }
  onLoadItem(key) {
    // carrega todos os menus ativos
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/item",
        "numero",
        "key_pergunta",
        key
      )
      .subscribe(data => {
        let tmp = JSON.parse(JSON.stringify(data));
        let dados = [];
        tmp.forEach(element => {
          if (element.status == "ativo") {
            dados.push(element);
          }
        });

        this.nivel = 0;
        this.menus = dados;
        if (this.menus === 0) {
          return this.menus;
        } else {
          this.menus = this.menus.map(res => {
            res.menu =
              res.nivel.toString() +
              res.key_master.toString() +
              res.key_child.toString();
            res.opcao =
              res.numero.toString() +
              res.nivel.toString() +
              res.key_master.toString() +
              res.key_child.toString();
            return res;
          });
        }
        let item = dados;
        this.filtroNivel(item, this.nivel).then(res => {
          this.item = res;
        });
      });
  }
  onEnviaMenu(texto, menu, contato, filtro) {
    let formulario = {};
    if (menu.texto == null) {
      texto = " ";//this.ctrl;
    }
    if (menu.midia) {
      formulario = {
        contato: contato[0].telefone,
        mensagem: texto,
        caption: texto,
        midia: menu.midia,
        type_midia: menu.type_midia
      };
    } else {
      formulario = {
        contato: contato[0].telefone,
        mensagem: texto
      };
    }
    //  console.log(formulario)
    this.enviarMsg(formulario);
  }
  filtroMenuPublicidade(numero) {
    return new Promise(resolve => {
      let res = this.publicidade.filter(obj => {
        return obj.numero == numero;
      });
      resolve(res);
    });
  }
  filtroChild(data, key_child) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.key_child == key_child;
      });
      resolve(res);
    });
  }
  filtroClassificado(data, menu) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.menu == menu;
      });
      let res_final = res.filter(obj => {
        return obj.status == "Publicado";
      });
      resolve(res_final);
    });
  }
  filtroPublicidade(data, hoje) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.publicar_ate >= hoje;
      });
      let res_final = res.filter(obj => {
        return obj.status == "Ativo";
      });
      resolve(res_final);
    });
  }
  filtroNoticia(data, hoje) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.publicar_ate >= hoje;
      });
      let res_final = res.filter(obj => {
        return obj.status == "Ativo";
      });
      resolve(res_final);
    });
  }
  filtroPesquisa(data, pesquisa) {
    let filtro = pesquisa.toLowerCase();
    return new Promise(resolve => {
      let res = data.filter(obj => {
        if (obj.busca.toLocaleLowerCase().indexOf(filtro) >= 0) {
          return true;
        }
        return false;
      });
      resolve(res);
    });
  }
  filtroMaster(data, key_master) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.key_master == key_master;
      });
      resolve(res);
    });
  }
  filtroUid(data, key_child) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.uid == key_child;
      });
      resolve(res);
    });
  }
  filtroOpcao(data, filtro) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        //   obj.menu.toLocaleLowerCase().indexOf(filtro.toLowerCase()) >= 0
        return obj.numero == filtro;
      });
      resolve(res);
    });
  }
  filtroMenu(data, filtro) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        //   obj.menu.toLocaleLowerCase().indexOf(filtro.toLowerCase()) >= 0
        return obj.menu == filtro;
      });
      // console.log(data , res, filtro)
      resolve(res);
    });
  }
  filtroMenuNoticia(numero) {
    return new Promise(resolve => {
      let res = this.noticia.filter(obj => {
        return obj.numero == numero;
      });
      resolve(res);
    });
  }
  filtroMenuGaleria(numero) {
    return new Promise(resolve => {
      let res = this.galeria.filter(obj => {
        return obj.numero == numero;
      });
      resolve(res);
    });
  }
  filtroNivel(data, nivel) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.nivel == nivel;
      });
      resolve(res);
    });
  }
  abreDenuncia(protocolo) {
    let unSubscribe = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/denuncia", "protocolo", protocolo).subscribe(data => {
      unSubscribe.unsubscribe()
      let dados = JSON.parse(JSON.stringify(data));
      if (dados.length > 0) {
        delete dados["key"];
        this.denuncia.push(dados[0]);
        let unSubs = this.genProvider
          .onGetFilterOrder(
            "dados/" + this.parametros.path + "/denuncia_body",
            "time",
            "protocolo",
            protocolo
          )
          .subscribe(data_body => {
            unSubs.unsubscribe()
            let dados_body = JSON.parse(JSON.stringify(data_body));
            dados_body.forEach(res => {
              delete res["key"];
              this.denuncia_body.push(res);
            });
          });
      }

    });
  }
  onLineAbrirdenuncia() {
    this.subAbrir = this.genProvider.onGetKey('dados/' + this.parametros.path + '/abrirdenuncia', this.parametros.instancia)
      .subscribe(data => {
        let res = JSON.parse(JSON.stringify(data));
        if (res.protocolo) {
          this.excluirDenuncia(res.protocolo)
          setTimeout(() => {
            this.abreDenuncia(res.protocolo)
            this.atualizaContato(res);
          }, 1000);
        }
      });
  }
  openChatSetor(key) {
    this.subAbrir = this.genProvider.onGetKey('dados/' + this.parametros.path + '/chatSetor', key)
      .subscribe(data => {
        let res = JSON.parse(JSON.stringify(data));
        if (res[0].protocolo) {
          let contato = {
            acesso: 2,
            bloqueado: res[0].bloqueado,
            coordenadas: res[0].coordenadas,
            data_hora: res[0].data_hora,
            data_nascimento: res[0].data_nascimento,
            invalida: res[0].invalida,
            localizacao: res[0].localizacao,
            nivel: res[0].nivel,
            nome: res[0].nome,
            status: "Ativo",
            telefone: res[0].telefone,
            time: res[0].time,
            tipo: res[0].tipo,
            key_pergunta: res[0].key_pergunta,
            protocolo: res[0].protocolo,
            key_master: res[0].key_master,
            key_child: res[0].key_child,
            opcao: res[0].opcao,
            menu: res[0].menu,
            countNatureza: res[0].countNatureza || "",
            natureza: res[0].natureza || ""
          }
          this.atualizaContato(contato);
        }
      });
  }
  onChatLive() {
    this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/chatLive", "time", "status", "Nova").subscribe(data => {
      this.chatLive = JSON.parse(JSON.stringify(data));
      //   console.log (this.chatLive)
      if (this.chatLive.length > 0) {
        this.onLoadPonto()
      }
    });
  }
  onFila() {
    // this.unSubChatLive = this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/chatLive", "time", "status", "Nova").subscribe(data => {
    //  this.chatLive = JSON.parse(JSON.stringify(data));
    //   console.log (this.chatLive.length)
    //   console.log (this.ponto.length)
    if ((this.chatLive.length > 0) && (this.ponto.length > 0)) {
      //      this.unSubChatLive.unsubscribe()
      //        this.unSubPonto.unsubscribe()
      this.onMontaFila()
    }
    // });
  }
  onMontaFila() {
    let c = 0;
    //     console.log (this.ponto)
    this.chatLive.forEach(e => {
      if (this.ponto.length > 0) {
        let dados = {
          key: this.ponto[0].key,
          protocolo: e.protocolo,
          atendimento_status: "Espera",
          atendimento_espera: Date.now()
        }
        this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ponto', dados)
        let dados_chat = {
          key: e.key,
          key_usuario: this.ponto[0].key_usuario,
          nome_usuario: this.ponto[0].nome,
          status: 'Espera',
          tempo_envio: Date.now(),
          data_envio: new DatePipe('pt-BR').transform(
            Date.now(),
            'd, MMMM yyyy - HH:mm'
          )
        }
        this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chatLive', dados_chat)
        let formulario = {
          contato: e.telefone,
          mensagem: "Você é o próximo a ser atendido, aguarde um momento."
          //   mensagem: "Voce será atendido por *"+this.ponto[0].nome +"*, aguarde um momento."

        };
        this.enviarMsg(formulario);
        const index = this.ponto.indexOf(this.ponto[0]);
        this.ponto.splice(index, 1);
      } else {
        c++
        if (this.dicas.length > 0) {
          let d = Math.floor(Math.random() * this.dicas.length);
          let msg_posicao = "Aguarde um momento, você ocupa a posição *" + c + "* da fila."
          let formulario = {
            contato: e.telefone,
            mensagem: this.dicas[d].descricao + this.ctrl + this.ctrl + msg_posicao
          };
          this.enviarMsg(formulario);
        } else {
          let msg_posicao = "Aguarde um momento, você ocupa a posição *" + c + "* da fila."
          let formulario = {
            contato: e.telefone,
            mensagem: msg_posicao
          };
          this.enviarMsg(formulario);
        }
      }
    });
    // this.onLoadPonto();
  }
  onLoadPonto() {
    this.unSubPonto = this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/ponto", "atendimento_time", "atendimento_status", "Livre").subscribe(data => {
      this.ponto = JSON.parse(JSON.stringify(data));
      this.unSubPonto.unsubscribe()
      //  console.log (this.ponto)
      if (this.ponto.length > 0) {
        this.onFila();
      }
    })
  }
  onLoadDicas() {
    this.genProvider.onGetAll('dados/' + this.parametros.path + '/dicas', 'descricao').subscribe(
      data => {
        this.dicas = JSON.parse(JSON.stringify(data));
      },
      err => console.log(err)
    );
  }
  onLine() {
    if (this.isPergunta) {
      // carregar tabelas
      this.onLoadDicas();
      this.onChatLive();
      console.log("Servidor OnLine!!");
      // enviar mesage,m pendente
      this.sendSubscription = this.genProvider
        .onGetfilter("sendMsg/", "instanceId", this.parametros.instancia)
        .subscribe(data => {
          let res = JSON.parse(JSON.stringify(data));
          if (res.length > 0) {
            let formulario = {
              contato: res[0].sendPhone.replace(/\D/g, ""),
              mensagem: res[0].value,
              midia: res[0].midia,
              type_midia: res[0].type,
              caption: res[0].caption
            };
            this.enviarMsg(formulario);
          }
        });

      // commando
      this.genProvider.onGetAll("dados/" + this.parametros.path + "/srvComando", "comando").subscribe(data => {
        let comando = JSON.parse(JSON.stringify(data));
        console.log(comando)
        if (comando.length > 0) {
          //          console.log("Executar comando")
          if (comando[0].comando == "finalizaChat") {
            this.onFinalizaChat(comando)
          } else if (comando[0].comando == "fila") {
            this.onFila();
          } else if (comando[0].comando == "loadPonto") {
            this.onLoadPonto()
          } else if (comando[0].comando == "atualizaContato") {
            this.openChatSetor(comando[0].protocolo)
          }
        }
      });

      this.genProvider.removeCollection("whatsStatus/", this.parametros.instancia)
      let susStatus = this.genProvider
        .onGetfilter("whatsStatus/", "instanceId", this.parametros.instancia)
        .subscribe(data => {
          let res = JSON.parse(JSON.stringify(data));
          //   console.log (res)
          if (res.length > 0) {
            let susDenuncia = this.genProvider.onGetfilter('dados/' + this.parametros.path + '/denuncia', 'protocolo', res[0].protocolo).subscribe(data => {
              this.onUpdateStatus(res[0], data[0])
              susDenuncia.unsubscribe();
            })
          }
        });
      // inicio facebook
      if (this.userIdFace) {
        let postSubscriptionMessager = this.genProvider.onGetfilter("faceMessager/", "userId", this.userIdFace).subscribe(data => {
          console.log("Receive facebook " + new DatePipe("pt-BR").transform(Date.now(), "mm:ss.SSS"));
          let now = new Date();
          let hora = new Date().getHours();
          if (now.getHours() >= 0 && now.getHours() < 12) {
            this.saudacao = "Bom dia";
          } else if (now.getHours() >= 12 && now.getHours() < 18) {
            this.saudacao = "Boa tarde";
          } else {
            this.saudacao = "Boa noite";
          }
          let res = JSON.parse(JSON.stringify(data));
          if (res.length > 0) {
            let type = "";
            let value = "";
            if (res[0].type == "location") {
              type = "location";
              value = res[0].lat.toString() + ";" + res[0].lng.toString();
            } else if (res[0].type) {
              value = res[0].midia;
              if (res[0].type == "audio") {
                type = "ppt";
              } else {
                type = res[0].type;
              }
            } else {
              value = res[0].message;
              res[0].type = "chat"
            }
            let msg = {
              origem: "messenger",
              id: res[0].userId,
              author: res[0].sender,
              type: res[0].type,
              body: value,
              date: res[0].date,
              senderName: "Usuario Messenger",
              messageNumber: res[0].sender
            };
            if (this.isAcesso == 0) {
              this.isAcesso = 1;
            } else {
              this.onContato(msg);
            }

          } else {
            this.isAcesso = 1;
          }
        },
          err => {
            console.log("o erro ", err);
          }
        );

      }

      // fim
      this.postSubscription = this.genProvider
        .onGetfilter("whatsPost/", "instanceId", this.parametros.instancia)
        .subscribe(
          data => {
            console.log("Receive Chat " + new DatePipe("pt-BR").transform(Date.now(), "mm:ss.SSS"));
            let now = new Date();
            let hora = new Date().getHours();
            if (now.getHours() >= 0 && now.getHours() < 12) {
              this.saudacao = "Bom dia";
            } else if (now.getHours() >= 12 && now.getHours() < 18) {
              this.saudacao = "Boa tarde";
            } else {
              this.saudacao = "Boa noite";
            }
            //         console.log (this.denuncia)
            //         console.log (this.denuncia_body)
            let res = JSON.parse(JSON.stringify(data));
            if (res.length > 0) {
              var tmp = res[0].author;
              var chatId_tmp = res[0].chatId;
              let telefone = tmp.replace(/\D/g, "");
              let chatId = chatId_tmp.replace(/\D/g, "");
              let midia = "";
              let value = "";
              //      console.log (this.Encrypt(telefone.toString()));
              //     console.log (this.Decrypt('63-63-67-59-67-61-58-60-64-60-60-6'));
              let msg = {
                origem: "whatsapp",
                id: res[0].id,
                author: telefone,
                type: res[0].type,
                body: res[0].body,
                date: res[0].time,
                senderName: res[0].senderName,
                messageNumber: res[0].messageNumber
              };
              if (res[0].type == "call_log") {
                let formulario = {
                  contato: telefone,
                  mensagem:
                    "ATENÇÃO! Este canal é um serviço automatizado, não é possível interagir por ligações via voz e vídeo."
                };
                this.enviarMsg(formulario);
              } else {
                if (res[0].body.substring(0, 4) == "http") {
                  midia = res[0].body;
                  value = null;
                } else {
                  midia = null;
                  value = res[0].body;
                }
                if (this.isAcesso == 0) {
                  this.isAcesso = 1;
                } else {
                  this.onContato(msg);
                }
              }
            } else {
              this.isAcesso = 1;
            }
          },
          err => {
            console.log("o erro ", err);
          }
        );
    } else {
      console.log(
        "WhatsApp OnLine com limitações! Não Existe um Grupo de Pergunta Padrão Ativa !!"
      );
    }
  }
  onValidaMsg(res) {
    let msg = JSON.stringify(res);
    let temp =
      "[" +
      msg.substring(0, msg.length - 1) +
      ', "token":"' +
      this.parametros.token +
      '","razao":"' +
      this.parametros.razao +
      '", "status":"' +
      status +
      '"}]';
    let dados = JSON.parse(temp);
    this.onContato(dados[0]);
  }
  salvarContato(data) {
    this.contatos.push(data);
  }
  excluirContato(telefone) {

    let res = this.contatos.filter(obj => {
      return obj.telefone == telefone;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
      this.onContatoOff(res[0]);
    }

  }
  excluirContatoOmni(telefone) {
    let res = this.contatos.filter(obj => {
      return obj.telefone == telefone;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
    }
  }
  excluirProtocolo(protocolo) {
    let res = this.contatos.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
    }
  }
  atualizaContato(data) {
    if (data.nivel == 0) {
      delete data["menu"];
    }
    if (data.acesso == -1) {
      data.acesso = 0
      this.onSalvarUsuario(data);
    }
    let res = this.contatos.filter(obj => {
      return obj.telefone == data.telefone;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      if (index >= 0) {
        this.contatos.splice(index, 1);
        this.contatos.push(data);
        if (data.nivel > 0) {
          this.onSalvarUsuario(data);
        }
      } else {
        this.contatos.push(data);
      }
    } else {
      this.contatos.push(data);
    }
  }
  pesquisaContato(data) {
    return new Promise(resolve => {
      let res = this.contatos.filter(obj => {
        return obj.telefone == data;
      });
      resolve(res);
    });
  }
  validaContato(data) {
    let temp = [];
    return new Promise(resolve => {
      let res = this.contatos.filter(obj => {
        return obj.telefone == data.author;
      });
      if (res.length > 0) {
        resolve(res);
      } else {
        this.genProvider.onIncrementKeyZeroDate('dados/' + this.parametros.path, "protocolo", 6).then((keyValue: any) => {
          // inico para pegar o protocolo
          if (data.senderName == "") {
            data.senderName = "Usuário Business";
          }
          let dados = {
            telefone: data.author,
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            ),
            nivel: 0,
            //          protocolo: Date.now().toString(),
            protocolo: keyValue,
            invalida: 0,
            acesso: -1,
            status: "Ativo",
            online: "on",
            nome: data.senderName,
            coordenadas: "",
            localizacao: "",
            data_nascimento: "",
            tipo: "Pergunta",
            time: Date.now(),
            bloqueado: false
          };
          temp.push(dados)
          resolve(temp)
          //       this.atualizaContato(dados);
        });
      }
    });
  }
  onLocalizacao(e) {
    return new Promise(resolve => {
      let coodenada = e.split(/\s*;\s*/);
      let geocoder = new google.maps.Geocoder();
      let latLng = new google.maps.LatLng(coodenada[0], coodenada[1]);
      geocoder.geocode({ location: latLng }, (results, status) => {
        let result = {
          localizacao: results[0].formatted_address,
          numero: results[0].address_components[0].long_name || " ",
          bairro: results[0].address_components[2].long_name || " ",
          cidade: results[0].address_components[3].long_name || " ",
          estado: results[0].address_components[4].long_name || " "
        };
        resolve(results[0].formatted_address);
      });
    });
  }
  onCancelaMsg(key, file, file_body) {
    this.genProvider.remove("dados/" + this.parametros.path + "/" + file, key);
    this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/" + file_body,
        "time",
        "protocolo",
        key
      )
      .subscribe(
        data => {
          let msg = JSON.parse(JSON.stringify(data));
          msg.forEach(element => {
            setTimeout(() => {
              this.genProvider.remove(
                "dados/" + this.parametros.path + "/" + file_body,
                element.key
              );
            }, 1000);
          });
        },
        err => {
          console.log(err);
        }
      );
  }
  onMudaPerfil(data) {
    // this.subscription.unsubscribe();
    console.log("PRIMEIRO ACESSO")
    let dados = {
      telefone: data.author,
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      acesso: -1,
      nome: "Primeiro Acesso",
      localizacao: "",
      data_nascimento: "",
      status: "ativo",
      time: Date.now()
    };
    this.atualizaContato(dados);
    let formulario = {
      contato: dados.telefone,
      mensagem: "Então vamos alterar seus dados. Digite agora o novo *nome*."
    };
    this.enviarMsg(formulario);
  }
  onPrimeiroAcesso(data) {
    if (data.senderName == "") {
      data.senderName = "Usuário Businnes";
    }
    let nome = "Primeiro Acesso";
    let localizacao = "";
    let acesso = -1;
    if (data.senderName) {
      nome = data.senderName;
      localizacao = "";
      acesso = -1;
    }
    //   console.log("primeiro acesso", this.pergunta.primeiro_atendimento);
    let tipo = "Pergunta";
    let status = "Ativo";
    if (!this.pergunta.primeiro_atendimento) {
      tipo = "whatscall";
      status = "Novo";
    }
    let dados = {
      telefone: data.author,
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      nivel: 0,
      invalida: 0,
      acesso: acesso,
      status: status,
      nome: nome,
      coordenadas: "",
      localizacao: localizacao,
      data_nascimento: "",
      tipo: tipo,
      time: Date.now(),
      bloqueado: false
    };
    if (!this.pergunta.primeiro_atendimento) {
      let whatscall = {
        telefone: data.author,
        nome: data.senderName,
        value: data.body,
        data_hora: new DatePipe("pt-BR").transform(
          Date.now(),
          "d, MMMM yyyy - HH:mm"
        ),
        status: "Espera",
        type: data.type || "chat",
        fromMe: false,
        time: Date.now()
      };

      let dados_whats = {
        status: "Nova",
        finalizada: "nao",
        nome: data.senderName,
        telefone: data.author,
        type: data.type,
        value: data.body,
        time: Date.now(),
        data_hora: new DatePipe("pt-BR").transform(
          Date.now(),
          "d, MMMM yyyy - HH:mm"
        )
      };
      this.genProvider.onSaveObjeto(
        "dados",
        this.parametros.path,
        "whatscall",
        whatscall
      );
      this.genProvider.onSaveDocKey(
        "dados/" + this.parametros.path + "/primeiro_atendimento",
        dados_whats.telefone,
        dados_whats
      );
      let formulario = {
        contato: data.author,
        mensagem: this.atendimento.replace("{{2}}", data.senderName)
      };
      this.enviarMsg(formulario);
    }

    this.atualizaContato(dados);
    if (this.primeiro_acesso_saudacao) {
      console.log("0");
    }

    if (nome == "Primeiro Acesso" && this.primeiro_acesso_saudacao) {
      console.log("1");
      let pergunta_nome = this.pergunta_nome.replace("{{4}}", this.saudacao);
      let formulario = {
        contato: dados.telefone,
        mensagem: pergunta_nome
      };
      this.enviarMsg(formulario);
    } else {
      let pergunta_nome = this.pergunta_nome.replace("{{4}}", this.saudacao);
      let texto = pergunta_nome.replace("{{2}}", dados.nome);
      let formulario = {};
      if (this.pergunta_nome_midia) {
        formulario = {
          contato: dados.telefone,
          mensagem: texto,
          caption: texto,
          midia: this.pergunta_nome_midia
        };
        this.enviarMsg(formulario);
        setTimeout(() => {
          formulario = {
            contato: dados.telefone,
            mensagem: texto
          };
          if (this.primeiro_acesso_saudacao) {
            this.enviarMsg(formulario);
          }
          let url = "dados/" + this.parametros.path + "/contato";
          console.log(dados);
          this.genProvider
            .onSaveDocKey(url, dados.telefone, dados)
            .then(t => { })
            .catch(e => {
              console.log("Atenção, Erro.", e);
            });
        }, 5000);
      } else {
        formulario = {
          contato: dados.telefone,
          mensagem: texto
        };
        if (this.primeiro_acesso_saudacao) {
          this.enviarMsg(formulario);
        }
        let url = "dados/" + this.parametros.path + "/contato";
        this.genProvider
          .onSaveDocKey(url, dados.telefone, dados)
          .then(t => { })
          .catch(e => {
            console.log("Atenção, Erro.", e);
          });
      }
    }
  }
  onStartAtendimento(contato, mensagem?: any) {
    let bem_vindo = this.bem_vindo.replace("{{4}}", this.saudacao);
    let tmp = bem_vindo.replace("{{2}}", contato[0].nome);
    if (this.bem_vindo_midia && tmp) {
      let formulario = {
        contato: contato[0].telefone,
        caption: tmp,
        midia: this.bem_vindo_midia,
        type_midia: this.type_bem_vindo_midia
      };
      this.enviarMsg(formulario);
    } else if (this.bem_vindo_midia) {
      let formulario = {
        contato: contato[0].telefone,
        midia: this.bem_vindo_midia,
        type_midia: this.type_bem_vindo_midia
      };
      this.enviarMsg(formulario);
    }
    let texto = tmp;
    let protocolo = this.ctrl + new DatePipe("pt-BR").transform(new Date(), "HH:mm:ss");
    if (this.informaProtocolo) {
      protocolo =
        this.ctrl + "*Seu Protocolo: " + contato[0].protocolo + "*";
    }
    this.filtroNivel(this.menus, 0).then(menu => {
      this.onMontaMenu(menu).then(
        res => {
          let menuOpcao = res;
          if (this.pergunta.type_midia) {
            let formulario = {
              contato: contato[0].telefone,
              caption:
                texto +
                this.ctrl +
                menuOpcao +
                this.ctrl +
                this.rodape +
                this.ctrl +
                protocolo,
              mensagem:
                texto +
                this.ctrl +
                menuOpcao +
                this.ctrl +
                this.rodape +
                this.ctrl +
                protocolo,
              midia: this.pergunta.imagem,
              type_midia: this.pergunta.type_midia
            };

            if (this.menu_texto_ativo) {
              //      console.log("menu texto ")
              this.menu_texto = this.menu_texto.replace(
                "{{4}}",
                this.saudacao
              );
              formulario = {
                contato: contato[0].telefone,
                caption:
                  this.menu_texto.replace("{{2}}", contato[0].nome) +
                  this.ctrl +
                  this.rodape +
                  this.ctrl +
                  protocolo,
                mensagem:
                  this.menu_texto.replace("{{2}}", contato[0].nome) +
                  this.ctrl +
                  this.rodape +
                  this.ctrl +
                  protocolo,
                midia: this.pergunta.imagem,
                type_midia: this.pergunta.type_midia
              };
            }

            this.enviarMsg(formulario);
            this.onChatStartNew(mensagem, contato);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem:
                texto +
                this.ctrl +
                menuOpcao +
                this.ctrl +
                this.rodape +
                this.ctrl +
                protocolo
            };
            if (this.menu_texto_ativo) {
              this.menu_texto = this.menu_texto.replace(
                "{{4}}",
                this.saudacao
              );
              formulario = {
                contato: contato[0].telefone,
                mensagem:
                  this.menu_texto.replace("{{2}}", contato[0].nome) +
                  this.ctrl +
                  this.rodape +
                  this.ctrl +
                  protocolo
              };
            }
            this.enviarMsg(formulario);
            this.onChatStartNew(mensagem, contato);
          }
        }
      );
    });
  }
  onFinalizaAtendimento(contato) {
    let formulario = {
      contato: contato[0].telefone,
      mensagem: this.mensagem.replace("{{2}}", contato[0].nome)
    };
    this.enviarMsg(formulario);
    this.onWebHookMsg(contato[0].protocolo);
    this.onOpcaoChat(contato, "-1");
    setTimeout(() => {
      this.excluirContato(contato[0].telefone);
    }, 5000);
  }
  onFinalizaMensagem(contato) {
    if (!this.mensagem) {
      this.mensagem = "{{2}}, seu atendiento foi finalizado.";
    }
    let formulario = {
      contato: contato[0].telefone,
      mensagem: this.mensagem.replace("{{2}}", contato[0].nome)
    };
    this.enviarMsg(formulario);
    this.onWebHookMsg(contato[0].protocolo);
    setTimeout(() => {
      this.excluirProtocolo(contato[0].protocolo);
      this.onOpcaoChat(contato, "-2");
    }, 3000);
  }
  onBloquearUsuario(data) {
    let dados = {
      key: data.author,
      telefone: data.author,
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      acesso: 99,
      time: 0,
      nivel: 0,
      tipo: "Bloqueado",
      status: "Bloqueado",
      bloqueado: true
    };
    console.log("Bloquear usuario ", this.contatos);
    const index = this.contatos.indexOf(data.author);
    this.contatos.splice(index, 1);
    this.genProvider
      .onSaveDocKey(
        "dados/" + this.parametros.path + "/contato",
        dados.telefone,
        dados
      )
      .then(t => {
        let formulario = {
          contato: dados.telefone,
          mensagem:
            "Desculpe por tudo, já removemos seu número da nossa lista e você não receberá mais nossas mensagens."
        };
        this.enviarMsg(formulario);
      })
      .catch(e => {
        console.log(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  async onChatStartNew(mensagem, contato) {
    contato[0].time = Date.now();
    contato[0].nivel = 0;
    contato[0].opcao = "0";
    contato[0].tipo = "Pergunta";
    //   console.log (mensagem)
    //   console.log (contato)
    // console.log('Taking a break...');
    //  await this.sleep(5000);
    //  console.log('Two seconds later, showing sleep in a loop...');
  }
  onChatStart(mensagem, contato) {

    if (contato[0].nivel == 0) {
      this.pesquisaPergunta(this.menus, mensagem.body).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          if (data[0].saudacao) {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: data[0].saudacao.replace("{{2}}", contato[0].nome)
            };
            this.enviarMsg(formulario);
          }
          mensagem.body = data[0].numero.toString();
          this.onChat(mensagem, contato);
        } else {
          this.pesquisaPerguntaChatbot(mensagem.body, this.chatbot, 0).then(
            result => {
              let dt = JSON.parse(JSON.stringify(result));
              if (dt.length > 0) {
                if (dt[0].rodape) {
                  dt[0].resposta =
                    dt[0].resposta + this.ctrl + this.pergunta.rodape_bot;
                }
                let texto = dt[0].resposta.replace("{{2}}", contato[0].nome);
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: texto
                };
                this.enviarMsg(formulario);
                if (dt[0].anexo_midia) {
                  let frm = {
                    contato: contato[0].telefone,
                    midia: dt[0].anexo_midia,
                    caption: dt[0].anexo_fullName,
                    type_midia: dt[0].anexo_type_midia
                  };
                  //         setTimeout(() => {
                  this.enviarMsg(frm);
                  //         }, 5000);
                }
                if (dt[0].retornaMenu == "true") {
                  setTimeout(() => {
                    this.onOpcaoChat(contato, "#");
                  }, this.parametros.menu_automatico_tempo * 1000);
                }
                // encaminhar inicio
                if (dt[0].acaobot == "true") {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem: dt[0].texto_acao
                  };
                  if (dt[0].texto_acao.length > 0) {
                    this.enviarMsg(formulario);
                  }
                  this.onOpcaoChat(contato, dt[0].opcao_acao);
                }

                // fim
              } else {
                this.onChat(mensagem, contato);
              }
            }
          );
        }
      });
    } else {
      this.onChat(mensagem, contato);
    }
  }
  onChat(mensagem, contato) {
    let formulario: any;
    let opcao: any;
    this.mensagem_full = mensagem;
    if (mensagem.body.substring(0, 7).toLowerCase() == "*perfil") {
      opcao = "*perfil";
      this.onMudaPerfil(mensagem);
    } else if (mensagem.body.substring(0, 6).toLowerCase() == "perfil") {
      opcao = "*perfil";
      this.onMudaPerfil(mensagem);
    } else {
      if (mensagem.body.substring(0, 5).toLowerCase() == "*sair") {
        opcao = "*sair";
        this.onFinalizaAtendimento(contato);
        this.excluirDenuncia(contato[0].protocolo);
        //   this.onBloquearUsuario(mensagem)  sair domenu_automatico_tempo atendimento
      } else if (mensagem.body.substring(0, 4).toLowerCase() == "sair") {
        opcao = "*sair";
        this.onFinalizaAtendimento(contato);
        this.excluirDenuncia(contato[0].protocolo);
        //    this.onBloquearUsuario(mensagem)
      } else if (mensagem.body.substring(0, 1) == "#") {
        opcao = "#";
      } else {
        opcao = mensagem.body.replace(/\D/g, "");
      }
      if (opcao == "") {
        //    console.log( 'opcao invalida ', contato[0] )
        contato[0].invalida = contato[0].invalida + 1;
        contato[0].time = Date.now();
        this.atualizaContato(contato[0]);
        let mensagem = "";
        if (contato[0].invalida == 1) {
          mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
        } else if (contato[0].invalida == 2) {
          mensagem = this.pergunta.opcao_invalida_principal_2.replace(
            "{{2}}",
            contato[0].nome
          );
        } else if (contato[0].invalida == 3) {
          mensagem = this.pergunta.opcao_invalida_principal_3.replace(
            "{{2}}",
            contato[0].nome
          );
          this.onSavePergunta(contato[0], this.mensagem_full)
        } else if (contato[0].invalida == 4) {
          mensagem = this.pergunta.atendimento_final.replace(
            "{{2}}",
            contato[0].nome
          );
          this.onSavePergunta(contato[0], this.mensagem_full)
        }
        if (contato[0].nivel > 0) {
          mensagem = this.pergunta.opcao_invalida.replace(
            "{{2}}",
            contato[0].nome
          );
        }
        if (this.mensagem_full.body.substring(0, 4) == "http") {
          mensagem = this.pergunta.opcao_invalida_outros.replace(
            "{{2}}",
            contato[0].nome
          );
        }

        let formulario = {};

        if (this.opcao_invalida_midia) {
          formulario = {
            contato: contato[0].telefone,
            caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
            midia: this.opcao_invalida_midia
          };
          this.enviarMsg(formulario);
          formulario = {
            contato: contato[0].telefone,
            mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
          };
          this.enviarMsg(formulario);
          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        } else {
          let formulario = {
            contato: contato[0].telefone,
            mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
          };
          if (contato[0].invalida < 3) {
            this.enviarMsg(formulario);
          } else {
            this.enviarMsg(formulario);
            if (this.finaliza_atendimento == "true") {
              this.onFinalizaAtendimento(contato);
            } else if (this.acaobot == "true") {
              formulario = {
                contato: contato[0].telefone,
                mensagem: this.texto_acao
              };
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, this.opcao_acao);
            }
          }
        }
      } else {
        this.onOpcaoChat(contato, opcao, mensagem.body);
      }
    }
    // let opcao = mensagem.body;
  }
  onOpcaoChat(contato, opcao, mensagem?: any) {
    let msg_value = mensagem;
    if (opcao == "-2") {
      // finaliza atendimento
      this.filtroNivel(this.menus, 0).then(menu => {
        this.onMontaMenu(menu).then(res => {
          let menuOpcao = res;
          let msg = "";
          let hora =
            this.ctrl + new DatePipe("pt-BR").transform(new Date(), "HH:mm:ss");
          if (this.informaProtocolo) {
            msg =
              this.atendimento_final.replace("{{2}}", contato[0].nome) +
              this.ctrl +
              "*Protocolo :" +
              contato[0].protocolo +
              "*";
          } else {
            msg =
              this.atendimento_final.replace("{{2}}", contato[0].nome) +
              this.ctrl +
              hora;
          }
          let formulario = {
            contato: contato[0].telefone,
            mensagem: msg,
            midia: this.pergunta.midia
          };
          this.enviarMsg(formulario);
        });
      });
    } else if (opcao == "-1") {
      this.filtroNivel(this.menus, 0).then(menu => {
        this.onMontaMenu(menu).then(res => {
          let msg = "";
          let hora =
            this.ctrl + new DatePipe("pt-BR").transform(new Date(), "HH:mm:ss");
          if (this.informaProtocolo) {
            msg =
              this.atendimento_final.replace("{{2}}", contato[0].nome) +
              this.ctrl +
              "*Protocolo :" +
              contato[0].protocolo +
              "*";
          } else {
            msg =
              this.atendimento_final.replace("{{2}}", contato[0].nome) +
              this.ctrl +
              hora;
          }
          let formulario = {
            contato: contato[0].telefone,
            mensagem: msg,
            midia: this.pergunta.midia
          };
          this.enviarMsg(formulario);
          //        this.excluirContato(contato[0].telefone);
        });
      });
    } else if (opcao == "0") {
      this.filtroNivel(this.menus, 0).then(menu => {
        this.onMontaMenu(menu).then(res => {
          let menuOpcao = res;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: menuOpcao + this.ctrl + this.rodape,
            midia: this.pergunta.midia
          };
          if (this.menu_texto_ativo) {
            this.menu_texto = this.menu_texto.replace("{{4}}", this.saudacao);
            formulario = {
              contato: contato[0].telefone,
              mensagem:
                this.menu_texto.replace("{{2}}", contato[0].nome) +
                this.ctrl +
                this.rodape,
              midia: this.pergunta.midia
            };
          }

          this.enviarMsg(formulario);
          (contato[0].data_hora = new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm"
          )),
            (contato[0].time = Date.now());
          contato[0].nivel = 0;
          contato[0].acesso = -1;
          contato[0].key_master = menu[0].key_master;
          contato[0].key_child = menu[0].key_child;
          contato[0].uid = menu[0].uid;
          contato[0].key_pergunta = this.key_pergunta;
          contato[0].opcao = opcao;
          contato[0].localizacao = false;
          contato[0].tipo = "Pergunta";
          this.atualizaContato(contato[0]);
        });
      });
    } else if (opcao == "#") {
      if (contato[0].nivel <= 1) {
        this.filtroNivel(this.menus, 0).then(menu => {
          this.onMontaMenu(menu).then(res => {
            let menuOpcao = res;
            let formulario = {
              contato: contato[0].telefone,
              //                 caption: menuOpcao +this.ctrl+this.rodape ,
              mensagem: menuOpcao + this.ctrl + this.rodape,
              midia: this.pergunta.midia
            };
            if (this.menu_texto_ativo) {
              this.menu_texto = this.menu_texto.replace("{{4}}", this.saudacao);
              formulario = {
                contato: contato[0].telefone,
                mensagem:
                  this.menu_texto.replace("{{2}}", contato[0].nome) +
                  this.ctrl +
                  this.rodape,
                midia: this.pergunta.midia
              };
            }

            this.enviarMsg(formulario);
            (contato[0].data_hora = new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            )),
              (contato[0].time = Date.now());
            contato[0].nivel = 0;
            contato[0].key_master = menu[0].key_master;
            contato[0].key_child = menu[0].key_child;
            contato[0].uid = menu[0].uid;
            contato[0].key_pergunta = this.key_pergunta;
            contato[0].opcao = opcao;
            contato[0].tipo = "Pergunta";
            contato[0].localizacao = false;
            this.atualizaContato(contato[0]);
          });
        });
      } else {
        this.onMenosNivel(contato);
      }
    } else if (contato[0].tipo == "Pergunta") {
      if (contato[0].nivel == 0) {
        //    console.log ('nivel 0 colocar aqui se a pessoa mandou um audio ou texto', opcao, mensagem)
        // sempre verificar se e uma opcao, se nao for vefiricar o tamanho da string para direcionar
        // e gravar como mensagem envianda.
        this.filtroNivel(this.menus, contato[0].nivel).then(res => {
          this.filtroOpcao(res, parseInt(opcao)).then(res => {
            let menu = JSON.parse(JSON.stringify(res));
            if (menu.length > 0) {
              this.onMaisNivel(menu[0], contato);
            } else {
              if (opcao != "*sair") {
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    contato: contato[0].telefone,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            }
          });
        });
      } else {
        this.filtroMaster(this.menus, contato[0].key_master).then(res => {
          this.filtroNivel(res, contato[0].nivel).then(res => {
            this.filtroOpcao(res, parseInt(opcao)).then(res => {
              let menu = JSON.parse(JSON.stringify(res));
              if (menu.length > 0) {
                if (menu[0].tipo == "Voltar Opcao") {
                  if (menu[0].valtarAll = "true") {
                    this.onOpcaoChat(contato, "0");
                  } else if (menu[0].nivel == 1) {
                    this.onOpcaoChat(contato, "0");
                  } else {
                    this.onMenosNivel(contato);
                  }
                } else {
                  this.onMaisNivel(menu[0], contato);
                }
              } else {
                console.log("Opção não Existe ", opcao);
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    contato: contato[0].telefone,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            });
          });
        });
      }
    } else if (contato[0].tipo == "Pergunta Mensagem") {
      console.log(contato[0])
      if (contato[0].nivel == 0) {
        //    console.log ('nivel 0 colocar aqui se a pessoa mandou um audio ou texto', opcao, mensagem)
        // sempre verificar se e uma opcao, se nao for vefiricar o tamanho da string para direcionar
        // e gravar como mensagem envianda.
        console.log("nivel = 0")
        this.filtroNivel(this.menus, contato[0].nivel).then(res => {
          this.filtroOpcao(res, parseInt(opcao)).then(res => {
            let menu = JSON.parse(JSON.stringify(res));
            if (menu.length > 0) {
              this.onMaisNivel(menu[0], contato);
            } else {
              if (opcao != "*sair") {
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    contato: contato[0].telefone,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            }
          });
        });
      } else {
        this.filtroMaster(this.menus, contato[0].key_master).then(res => {
          this.filtroNivel(res, contato[0].nivel).then(res => {
            this.filtroOpcao(res, parseInt(opcao)).then(res => {
              let menu = JSON.parse(JSON.stringify(res));
              console.log(menu)
              if (menu.length > 0) {
                if (menu[0].tipo == "Voltar Opcao") {
                  if (menu[0].valtarAll = "true") {
                    this.onOpcaoChat(contato, "0");
                  } else if (menu[0].nivel == 1) {
                    this.onOpcaoChat(contato, "0");
                  } else {
                    this.onMenosNivel(contato);
                  }

                } else {
                  console.log('mais nivel', menu[0], contato)
                  this.onMaisNivel(menu[0], contato);
                }
              } else {
                console.log("Opção não Existe ", opcao);
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    contato: contato[0].telefone,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            });
          });
        });
      }
    } else if (contato[0].tipo == "Pesquisa_Existe") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuPublicidade(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        //    console.log (data[0])
        if (data.length > 0) {
          let element = data[0];
          let nome = new CamelcasePipe().transform(element.nome).trim();
          let telefone = this.validaCampoProvider.validaTelefoneZap(
            element.telefone
          );
          let texto = "*" + nome + "*" + this.ctrl;

          if (element.mostra_localizacao) {
            texto += "_" + element.localizacao + "_" + this.ctrl;
          } else {
            texto += "_" + element.complemento + "_" + this.ctrl;
          }
          texto += telefone + this.ctrl + this.ctrl;

          texto += element.texto + this.ctrl + this.ctrl + this.msg_navegacao;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          this.enviarMsg(formulario);
          let localizacao = {
            contato: contato[0].telefone,
            localizacao: element.localizacao || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            latitude: element.latitude,
            longitude: element.longitude
          };
          this.sendAll(localizacao, "localizacao");
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          console.log("opcao invalida ", contato[0]);
          contato[0].invalida = contato[0].invalida + 1;
          contato[0].time = Date.now();
          this.atualizaContato(contato[0]);

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaoChat(contato, '#');
    } else if (contato[0].tipo == "Publicidade") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuPublicidade(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let element = data[0];
          let nome = new CamelcasePipe().transform(element.nome).trim();
          let telefone = this.validaCampoProvider.validaTelefoneZap(
            element.telefone
          );
          let texto = "*" + nome + "*" + this.ctrl;

          if (element.mostra_localizacao) {
            texto += "_" + element.localizacao + "_" + this.ctrl;
          } else {
            texto += "_" + element.complemento + "_" + this.ctrl;
          }
          if (telefone) {
            texto += telefone + this.ctrl;
          }
          if (element.desconto) {
            texto +=
              "*Desconto de até " +
              element.desconto +
              "%*" +
              this.ctrl +
              this.ctrl;
          } else {
            texto += this.ctrl;
          }
          /*      texto += "Publicado: " + element.data_hora + this.ctrl+ this.ctrl; */
          texto += element.texto + this.ctrl + this.ctrl + this.msg_navegacao;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          this.enviarMsg(formulario);
          let localizacao = {
            contato: contato[0].telefone,
            localizacao: element.localizacao || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            latitude: element.latitude,
            longitude: element.longitude
          };
          //                   setTimeout(() => {
          this.sendAll(localizacao, "localizacao");
          //                    }, 5000);

          /*
                              if (i >= data.length){
                                setTimeout(() => {
                                  let formulario = {
                                    contato: contato[0].telefone,
                                    mensagem: '*Total da Lista: '+i+'*',
                                    type_midia : menu[0].type_midia
                                  };
                                  this.enviarMsg(formulario);
                                  this.onOpcaoChat(contato, '#');
                              }, 5000);
                              }
                  */
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaoChat(contato, '#');
    } else if (contato[0].tipo == "Noticia") {
      console.log("situacao do menu 2");
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuNoticia(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let element = data[0];
          //      let data_publicacao = new DatePipe('pt-BR').transform(element.data_hora, 'd, MMMM yyyy ');
          let texto = "*" + element.titulo + "*" + this.ctrl;
          texto += "_" + element.data_hora + "_" + this.ctrl;
          //      texto += "Publicado: " + element.data_hora + this.ctrl+ this.ctrl; */
          texto += this.ctrl + element.descricao + this.ctrl + this.ctrl;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          this.enviarMsg(formulario);
          setTimeout(() => {
            this.onOpcaoChat(contato, "#");
          }, 5000);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaoChat(contato, '#');
    } else if (contato[0].tipo == "Galeria") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuGaleria(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let msg = {
            contato: contato[0].telefone,
            mensagem: "⏳ Aguarde..." + this.ctrl + "Pode demorar um pouco..."
          };
          this.enviarMsg(msg);
          let element = data[0];
          let titulo = new CamelcasePipe().transform(element.titulo).trim();
          let texto = "";
          if (
            element.type_midia == "jpg" ||
            element.type_midia == "jpeg" ||
            element.type_midia == "png"
          ) {
            texto = "*🖼 " + titulo + "*" + this.ctrl;
          } else if (element.type_midia == "mp4") {
            texto = "*📹 " + titulo + "*" + this.ctrl;
          } else if (element.type_midia == "ogg") {
            texto = "*🔊 " + titulo + "*" + this.ctrl;
          } else {
            texto = "*📰 " + titulo + "*" + this.ctrl;
          }
          texto += "_" + element.descricao + "_" + this.ctrl;
          texto +=
            "_" +
            element.data_hora +
            "_" +
            this.ctrl +
            this.ctrl +
            this.msg_navegacao;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          //        console.log (formulario)
          this.enviarMsg(formulario);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel == 0) {
            // gravar pergunta
            let data = {
              telefone: contato[0].telefone,
              value: msg_value,
              date: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nome: contato[0].nome,
              status: "Novo"
            };
            this.genProvider.onSaveObjeto(
              "dados",
              this.parametros.path,
              "intensao",
              data
            );
          }

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaoChat(contato, '#');
    } else if (contato[0].tipo == "EnqueteEncerrada") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuEnqueteEncerrada(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));

        if (data.length > 0) {
          let navegacao =
            "A qualquer momento digite 0⃣ para voltar ao menu principal ou digite o número de uma nova enquete.";
          let element = data[0];
          let titulo = new CamelcasePipe().transform(element.nome).trim();
          let texto = "*" + titulo + "*" + this.ctrl;
          texto += "_" + element.texto + "_" + this.ctrl + this.ctrl;
          texto += "Iniciada em: " + element.data_hora + this.ctrl;
          texto += "Encerrada em: " + element.data_encerramento + this.ctrl;
          texto +=
            "Participantes: " +
            element.votos +
            this.ctrl +
            this.ctrl +
            navegacao;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.imgChart,
            type_midia: "jpg",
            caption: texto
          };
          //        console.log (formulario)
          this.enviarMsg(formulario);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaoChat(contato, '#');
    } else if (contato[0].tipo == "Enquete") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuEnquete(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        // verificar usuario
        if (data.length > 0) {
          this.onContatoEnquete(
            contato[0].telefone,
            data[0].key_enquete
          ).then(res => {
            let result = JSON.parse(JSON.stringify(res));
            if (result.length == 0) {
              this.onMontaMenuEnqueteOpcao(data[0].key_enquete).then(res => {
                let navegacao =
                  "A qualquer momento digite 0⃣ para cencelar e voltar ao menu principal";
                let item = JSON.parse(JSON.stringify(res));
                let texto = "";
                if (data[0].mostra_texto) {
                  texto =
                    "*" +
                    data[0].nome +
                    "*" +
                    this.ctrl +
                    data[0].texto +
                    this.ctrl +
                    item +
                    this.ctrl +
                    this.ctrl +
                    navegacao;
                } else {
                  texto =
                    "*" +
                    data[0].nome +
                    "*" +
                    this.ctrl +
                    item +
                    this.ctrl +
                    this.ctrl +
                    navegacao;
                }
                if (item.length > 0) {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
                    midia: data[0].midia,
                    type_midia: data[0].type_midia,
                    caption: texto || ""
                  };
                  this.enviarMsg(formulario);
                  contato[0].acesso = 2;
                  contato[0].time = Date.now();
                  contato[0].nivel = 2;
                  contato[0].tipo = "EnqueteOpcao";
                  this.atualizaContato(contato[0]);
                }
              });
            } else {
              // usuario ja participu desta enquete
              let texto =
                "{{2}} sua participação já foi registrada." +
                this.ctrl +
                "*Selecione outra opção ou digite a qualquer momento digite 0⃣ para voltar ao menu principal*";
              texto = texto.replace("{{2}}", contato[0].nome);
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto || "" //+this.ctrl+this.ctrl+this.msg_navegacao,
              };
              this.enviarMsg(formulario);
            }
          });
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel == 0) {
            // gravar pergunta
            let data = {
              telefone: contato[0].telefone,
              value: msg_value,
              date: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nome: contato[0].nome,
              status: "Novo"
            };
            this.genProvider.onSaveObjeto(
              "dados",
              this.parametros.path,
              "intensao",
              data
            );
          }

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};
          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //       this.onOpcaoChat(contato, '#');
    } else if (contato[0].tipo == "EnqueteOpcao") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuEnqueteOpcao(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let texto =
            "Parabéns {{2}}🎉, seu participação foi registrada com sucesso.";
          let voto = {
            key_enquete: data[0].key_enquete,
            key_enquetePergunta: data[0].key_enquetePergunta,
            numero: data[0].numero,
            texto: data[0].texto,
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            ),
            time: Date.now(),
            telefone: contato[0].telefone,
            nome: contato[0].nome,
            localizacao: contato[0].localizacao
          };
          this.genProvider
            .onSaveObjeto("dados", this.parametros.path, "enquete_voto", voto)
            .then(t => {
              // atualiza a opcao
              this.genProvider
                .onUpdateVoto(
                  "dados/" + this.parametros.path + "/enquete_item",
                  data[0].key_enquetePergunta.toString()
                )
                .then(t => { })
                .catch(e => {
                  alert(
                    "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
                  );
                  console.log(e);
                });
              // atualiza a pergunta
              this.genProvider
                .onUpdateVoto(
                  "dados/" + this.parametros.path + "/enquete",
                  data[0].key_enquete.toString()
                )
                .then(t => { })
                .catch(e => {
                  alert(
                    "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
                  );
                  console.log(e);
                });
            })
            .catch(e => {
              alert(
                "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
              );
              console.log(e);
            });

          texto = texto.replace("{{2}}", contato[0].nome);
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto || "" //+this.ctrl+this.ctrl+this.msg_navegacao,
          };
          this.enviarMsg(formulario);
          setTimeout(() => {
            this.onOpcaoChat(contato, "0");
          }, 5000);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel == 0) {
            // gravar pergunta
            let data = {
              telefone: contato[0].telefone,
              value: msg_value,
              date: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nome: contato[0].nome,
              status: "Novo"
            };
            this.genProvider.onSaveObjeto(
              "dados",
              this.parametros.path,
              "intensao",
              data
            );
          }

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              contato: contato[0].telefone,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //       this.onOpcaoChat(contato, '#');
    }
  }
  // sequencia do fluxo de opcoes
  onMaisNivel(data, contato) {
    // seleciona um menu de nivel acima com as opcoes de tipo de menu
    let tmp = data.texto.replace(/\n/g, "");
    let menu_opcao = tmp.replace(/\*/g, "");
    let nivel = data.nivel + 1;
    let filtro = nivel.toString() + data.key_master.toString() + data.uid.toString();
    this.filtroMenu(this.menus, filtro).then(res => {
      let menu = JSON.parse(JSON.stringify(res));
      // atualiza contato
      if (menu.length > 0) {
        (contato[0].data_hora = new DatePipe("pt-BR").transform(
          Date.now(),
          "d, MMMM yyyy - HH:mm"
        )),
          (contato[0].acesso = 2);
        contato[0].time = Date.now();
        contato[0].nivel = nivel;
        contato[0].key_master = menu[0].key_master;
        contato[0].key_child = menu[0].key_child;
        contato[0].uid = menu[0].uid;
        contato[0].key_pergunta = this.key_pergunta;
        contato[0].tipo = menu[0].tipo;
        //     contato[0].tipo = data.tipo;
        contato[0].menu = menu_opcao;
        this.atualizaContato(contato[0]);
        //
        if (menu[0].tipo == "Informação") {
          let navegacao = "*" + this.msg_navegacao + "*";
          if (this.parametros.menu_automatico) {
            navegacao = "";
          }
          let tempo = 0;
          menu.forEach(res => {
            let texto = res.texto + this.ctrl + navegacao;
            setTimeout(() => {
              this.onEnviaMenu(texto, res, contato, "banner");
            }, tempo);
            tempo = 1000;
          });
          if (this.parametros.menu_automatico) {
            setTimeout(() => {
              if (menu[0].valtarAll = "true") {
                this.onOpcaoChat(contato, "0");
              } else if (menu[0].nivel == 1) {
                this.onOpcaoChat(contato, "0");
              } else {
                this.onMenosNivel(contato);
              }
            }, this.parametros.menu_automatico_tempo * 1000);
          }
        } else if (menu[0].tipo == "Voltar Opcao") {
          let navegacao = "*" + this.msg_navegacao + "*";
          if (this.parametros.menu_automatico) {
            navegacao = "";
          }
          let tempo = 0;
          menu.forEach(res => {
            let texto = res.texto + this.ctrl + navegacao;
            setTimeout(() => {
              this.onEnviaMenu(texto, res, contato, "banner");
            }, tempo);
            tempo = 1000;
          });
          if (this.parametros.menu_automatico) {
            if (menu[0].valtarAll = "true") {
              this.onOpcaoChat(contato, "0");
            } else if (menu[0].nivel == 1) {
              this.onOpcaoChat(contato, "0");
            } else {
              this.onMenosNivel(contato);
            }
          }
        } else if (menu[0].tipo == "Emprego") {
          let formulario = {
            contato: contato[0].telefone,
            midia: menu[0].midia,
            mensagem:
              menu[0].texto +
              this.ctrl +
              this.ctrl +
              "Aguarde! Estamos processando seu pedido...",
            caption:
              menu[0].texto +
              this.ctrl +
              this.ctrl +
              "Aguarde! Estamos processando seu pedido...",
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);
          setTimeout(() => {
            let dataAtual = new Date();
            let inicio = dataAtual.setDate(dataAtual.getDate());
            let subscription = this.genProvider
              .onGetFilterOrder(
                "dados/" + this.parametros.path + "/emprego",
                "status",
                "publicar_ate",
                inicio,
                ">="
              )
              .subscribe(data => {
                subscription.unsubscribe();
                let emprego = JSON.parse(JSON.stringify(data));
                let i = 0;
                let contador = 0;
                if (emprego.length > 0) {
                  emprego.forEach(element => {
                    i++;
                    contador++;

                    let titulo = new CamelcasePipe()
                      .transform(element.titulo)
                      .trim();
                    let ate = new DatePipe("pt-BR").transform(
                      element.publicar_ate,
                      "d, MMMM yyyy"
                    );
                    let texto = "*" + titulo + "*" + this.ctrl + this.ctrl;

                    texto +=
                      "Descrição: " + element.descricao + this.ctrl + this.ctrl;
                    texto +=
                      "Requisitos: " +
                      element.requisito +
                      this.ctrl +
                      this.ctrl;
                    texto +=
                      "*Comparecer até:* " +
                      "*" +
                      ate +
                      "*" +
                      this.ctrl +
                      this.ctrl;
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: texto,
                      type_midia: menu[0].type_midia
                    };
                    this.enviarMsg(formulario);
                    if (contador >= 5) {
                      contador = 0;
                      let formulario = {
                        contato: contato[0].telefone,
                        caption: element.descricao,
                        mensagem: element.descricao
                      };
                      this.enviarMsg(formulario);
                    }
                    if (i >= emprego.length) {
                      setTimeout(() => {
                        let formulario = {
                          contato: contato[0].telefone,
                          mensagem: "*Total da Lista: " + i + "*",
                          type_midia: menu[0].type_midia
                        };
                        this.enviarMsg(formulario);
                        this.onOpcaoChat(contato, "#");
                      }, 5000);
                    }
                  });
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      "*Desculpe! Não existe anúncios de vagas de emprego no momento!*",
                    type_midia: menu[0].type_midia
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaoChat(contato, "#");
                  }, 5000);
                }
              });
          }, 5000);
        } else if (menu[0].tipo == "Pesquisa") {
          let formulario = {
            contato: contato[0].telefone,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);
        } else if (menu[0].tipo == "API") {
          let texto =
            menu[0].texto +
            this.ctrl +
            "Para cancelar, digite e envie apenas o número *_0_* ou *sair*";
          contato[0].api = menu[0].api || "";
          this.atualizaContato(contato[0]);
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Consulta") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          contato[0].api = menu[0].api || "";
          contato[0].token = menu[0].token;
          this.atualizaContato(contato[0]);
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Consulta Denuncia") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.atualizaContato(contato[0]);
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if ((menu[0].tipo == "Mensagem") || (menu[0].tipo == "Mensagem Chat") || (menu[0].tipo == "Mensagem Ticket")) {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Setor") {
          contato[0].chatSetor = false;
          this.atualizaContato(contato[0]);
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
          // Notificar Atendente
          let mensagem = {
            author: contato[0].telefone,
            body: "Usuário aguardando atendimento...",
            date: contato[0].time,
            senderName: contato[0].nome,
            type: "chat",
            notifica_usuario: true
          }
          this.notificarAtendente(mensagem, contato);
        } else if (menu[0].tipo == "Localizacao") {
          contato[0].localizacao = false;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Sugestao") {
          contato[0].sugestao = false;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Ouvidoria") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Denuncia") {
          let texto = menu[0].texto + this.ctrl + this.cancelar_denuncia;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Denuncia Natureza") {
          contato[0].countNatureza = 0;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Denuncia Localizacao") {
          contato[0].localizacao = false;
          let texto = menu[0].texto + this.ctrl + this.cancelar_denuncia;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Saude") {
          contato[0].localizacao = false;
          contato[0].saude = 0;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Publicidade") {
          //   console.log ('situacao do menu', menu[0])
          let formulario = {
            contato: contato[0].telefone,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          //    this.enviarMsg(formulario);

          let dataAtual = new Date();
          let inicio = dataAtual.setDate(dataAtual.getDate());
          let url = "dados/" + this.parametros.path + "/cliente";
          let subscription = this.genProvider
            .onGetFilterOrder(url, "nome", "categoria", menu[0].key_child)
            .subscribe(
              data => {
                let publicidade = data;
                subscription.unsubscribe();
                let i = 0;
                //       setTimeout(() => {
                if (publicidade.length > 0) {
                  this.filtroPublicidade(publicidade, inicio).then(res => {
                    let data = JSON.parse(JSON.stringify(res));
                    if (data.length > 0) {
                      this.onMontaMenuPublicidade(data).then(res => {
                        let formulario = {
                          contato: contato[0].telefone,
                          mensagem:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          caption:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: menu[0].midia,
                          type_midia: menu[0].type_midia
                        };
                        this.enviarMsg(formulario);
                      });
                    } else {
                      let formulario = {
                        contato: contato[0].telefone,
                        mensagem:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! No momento esta opção não esta disponível.*!*",
                        caption:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! No momento esta opção não esta disponível.*!*",
                        midia: menu[0].midia,
                        type_midia: menu[0].type_midia
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaoChat(contato, "#");
                      }, 5000);
                    }
                  });
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! No momento esta opção não esta disponível.*!*",
                    caption:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! No momento esta opção não esta disponível.*!*",
                    midia: menu[0].midia,
                    type_midia: menu[0].type_midia
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaoChat(contato, "#");
                  }, 5000);
                }
                //    }, 5000);
              },
              err => console.log(err)
            );
        } else if (menu[0].tipo == "Noticia") {
          console.log("Monta o Menu com as Noticias");
          let formulario = {
            contato: contato[0].telefone,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          //    this.enviarMsg(formulario);

          let dataAtual = new Date();
          let inicio = dataAtual.setDate(dataAtual.getDate());
          let url = "dados/" + this.parametros.path + "/noticia";
          let subscription = this.genProvider
            .onGetFilterOrder(url, "titulo", "publicar_ate", inicio, ">=")
            .subscribe(
              data => {
                //  let subscription = this.genProvider.onGetFilterOrder(url, 'data_pubicacao', 'status', 'Ativo').subscribe(data => {
                let noticia = data;
                subscription.unsubscribe();
                let i = 0;
                //       setTimeout(() => {
                if (noticia.length > 0) {
                  this.filtroNoticia(noticia, inicio).then(res => {
                    let data = JSON.parse(JSON.stringify(res));
                    if (data.length > 0) {
                      this.onMontaMenuNoticia(data).then(res => {
                        let formulario = {
                          contato: contato[0].telefone,
                          mensagem:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          caption:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: menu[0].midia,
                          type_midia: menu[0].type_midia
                        };
                        this.enviarMsg(formulario);
                      });
                    } else {
                      let formulario = {
                        contato: contato[0].telefone,
                        mensagem:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! Não existe notícias no momento!*",
                        caption:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! Não existe notícias no momento!*",
                        midia: menu[0].midia,
                        type_midia: menu[0].type_midia
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaoChat(contato, "#");
                      }, 5000);
                    }
                  });
                } else {
                  let formulario = {
                    contato: contato[0].telefone,
                    mensagem:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! Não existe notícias no momento!*",
                    caption:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! Não existe notícias no momento!*",
                    midia: menu[0].midia,
                    type_midia: menu[0].type_midia
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaoChat(contato, "#");
                  }, 5000);
                }
                //    }, 5000);
              },
              err => console.log(err)
            );
        } else if (menu[0].tipo == "Galeria") {
          let texto = menu[0].texto;
          let midia = "";
          let type_midia = "";
          midia = menu[0].midia;
          type_midia = menu[0].type_midia;
          let subscription = this.genProvider
            .onGetAllFilterPageDesc(
              "dados/" + this.parametros.path + "/galeria",
              "ordem",
              "status",
              "Ativo",
              99999
            )
            .subscribe(
              res => {
                subscription.unsubscribe();
                let galeria = JSON.parse(JSON.stringify(res));
                subscription.unsubscribe();
                let i = 0;
                if (galeria.length > 0) {
                  this.onMontaMenuGaleria(galeria).then(res => {
                    let formulario = {
                      midia: midia,
                      type_midia: type_midia,
                      contato: contato[0].telefone,
                      mensagem:
                        texto +
                        this.ctrl +
                        res +
                        this.ctrl +
                        this.msg_navegacao,
                      caption:
                        texto + this.ctrl + res + this.ctrl + this.msg_navegacao
                    };
                    this.enviarMsg(formulario);
                  });
                } else {
                  let formulario = {
                    midia: midia,
                    type_midia: type_midia,
                    contato: contato[0].telefone,
                    mensagem:
                      "*Desculpe! Não existe videos/imagens/documentos disponíveis no momento!*",
                    caption:
                      "*Desculpe! Não existe videos/imagens/documentos disponíveis no momento!*"
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaoChat(contato, "#");
                  }, 3000);
                }
              },
              err => console.log(err)
            );
        } else if (menu[0].tipo == "Classificado") {
          let formulario = {
            contato: contato[0].telefone,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);

          setTimeout(() => {
            let dataAtual = new Date();
            let inicio = dataAtual.setDate(dataAtual.getDate() - 5); // subtrai 3 dias
            //      let fim = dataFinal.setDate(dataFinal.getDate() + 1);
            //      let iniDate = new DatePipe('pt-BR').transform(inicio, 'yyyy-MM-dd');
            //      let finDate = new DatePipe('pt-BR').transform(fim, 'yyyy-MM-dd');
            let subscription = this.genProvider
              .onGetFilterOrder(
                "dados/" + this.parametros.path + "/classificado",
                "status",
                "time",
                inicio,
                ">="
              )
              .subscribe(
                data => {
                  subscription.unsubscribe();
                  let classificados = JSON.parse(JSON.stringify(data));
                  let i = 0;
                  let contador = 0;
                  if (classificados.length > 0) {
                    this.filtroClassificado(classificados, menu_opcao).then(
                      res => {
                        let data = JSON.parse(JSON.stringify(res));
                        if (data.length > 0) {
                          data.forEach(element => {
                            i++;
                            contador++;
                            let nome = new CamelcasePipe()
                              .transform(element.nome)
                              .trim();
                            let telefone = this.validaCampoProvider.validaTelefoneZap(
                              element.telefone
                            );
                            let texto = "*" + nome + "*" + this.ctrl;
                            texto += "*" + telefone + "*" + this.ctrl;
                            texto +=
                              "_" +
                              element.data_hora +
                              "_" +
                              this.ctrl +
                              this.ctrl;
                            texto += element.value + this.ctrl;
                            let formulario = {
                              contato: contato[0].telefone,
                              mensagem: texto,
                              caption: texto,
                              midia: element.imagem,
                              type_midia: menu[0].type_midia
                            };
                            this.enviarMsg(formulario);
                            if (i >= data.length) {
                              setTimeout(() => {
                                let formulario = {
                                  contato: contato[0].telefone,
                                  mensagem: "*Total da Lista: " + i + "*",
                                  type_midia: menu[0].type_midia
                                };
                                //   this.enviarMsg(formulario);
                                this.onOpcaoChat(contato, "#");
                              }, 10000);
                            }
                          });
                        } else {
                          let formulario = {
                            contato: contato[0].telefone,
                            mensagem:
                              "*" +
                              menu_opcao +
                              "*" +
                              this.ctrl +
                              this.escolha_opcao +
                              menu +
                              this.ctrl +
                              this.msg_navegacao
                          };
                          this.enviarMsg(formulario);
                          formulario = {
                            contato: contato[0].telefone,
                            mensagem:
                              "*Desculpe! No momento esta opção não esta disponível.*!*"
                          };
                          this.enviarMsg(formulario);
                          setTimeout(() => {
                            this.onOpcaoChat(contato, "#");
                          }, 5000);
                        }
                      }
                    );
                  } else {
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem:
                        "*" +
                        menu_opcao +
                        "*" +
                        this.ctrl +
                        this.escolha_opcao +
                        menu +
                        this.ctrl +
                        this.msg_navegacao
                    };
                    this.enviarMsg(formulario);
                    formulario = {
                      contato: contato[0].telefone,
                      mensagem:
                        "*Desculpe! No momento esta opção não esta disponível.*!*"
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaoChat(contato, "#");
                    }, 5000);
                  }
                },
                err => console.log(err)
              );
          }, 5000);
        } else if (menu[0].tipo == "Midia") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto.replace("{{2}}", contato[0].nome),
            caption: texto.replace("{{2}}", contato[0].nome),
            midia: menu[0].midia,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);
        } else if (menu[0].tipo == "Anunciar") {
          let texto = menu[0].texto;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: texto.replace("{{2}}", contato[0].nome),
            caption: texto.replace("{{2}}", contato[0].nome),
            midia: menu[0].midia,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);
        } else if (menu[0].tipo == "Atendimento") {
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", contato[0].nome);
            texto_menu = tmp;
          }
          this.onMontaMenuAtendimento().then(res => {
            let texto =
              texto_menu +
              this.ctrl +
              "*" +
              menu_opcao +
              "*" +
              this.ctrl +
              this.escolha_opcao +
              this.ctrl +
              res +
              this.ctrl +
              this.msg_navegacao;
            let formulario = {
              contato: contato[0].telefone,
              mensagem: texto,
              caption: texto,
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
          });
        } else if (menu[0].tipo == "EnqueteEncerrada") {
          // INCIO
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", contato[0].nome);
            texto_menu = tmp;
          }
          if (this.enqueteEncerrada.length > 0) {
            this.onMontaMenuEnqueteEncerrada().then(res => {
              let texto =
                texto_menu +
                this.ctrl +
                "*" +
                menu_opcao +
                "*" +
                this.ctrl +
                this.escolha_opcao +
                this.ctrl +
                res +
                this.ctrl +
                this.msg_navegacao;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto,
                caption: texto,
                midia: menu[0].midia,
                type_midia: menu[0].type_midia
              };
              this.enviarMsg(formulario);
            });
          } else {
            let formulario = {
              contato: contato[0].telefone,
              mensagem:
                "No momento não existe enquetes encerradas disponíveis.",
              caption: "No momento não existe enquetes encerradas disponíveis.",
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
            setTimeout(() => {
              this.onOpcaoChat(contato, "0");
            }, 5000);
          }
        } else if (menu[0].tipo == "Enquete") {
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", contato[0].nome);
            texto_menu = tmp;
          }
          this.onMontaMenuEnquete().then(res => {
            let texto =
              texto_menu +
              this.ctrl +
              "*" +
              menu_opcao +
              "*" +
              this.ctrl +
              this.escolha_opcao +
              this.ctrl +
              res +
              this.ctrl +
              this.msg_navegacao;
            let formulario = {
              contato: contato[0].telefone,
              mensagem: texto,
              caption: texto,
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
          });
        } else {
          // monta o menu de opcao
          this.onMontaMenu(menu).then(res => {
            let menu = res;
            let formulario = {};
            if (data.tipo == "Pergunta Mensagem") {
              formulario = {
                contato: contato[0].telefone,
                mensagem: data.saudacao + this.ctrl + menu + this.ctrl + this.msg_navegacao
              };
            } else {
              formulario = {
                contato: contato[0].telefone,
                mensagem:
                  "*" +
                  menu_opcao +
                  "*" +
                  this.ctrl +
                  this.escolha_opcao +
                  menu +
                  this.ctrl +
                  this.msg_navegacao,
                caption:
                  "*" +
                  menu_opcao +
                  "*" +
                  this.ctrl +
                  this.escolha_opcao +
                  menu +
                  this.ctrl +
                  this.msg_navegacao
              };
            }
            this.enviarMsg(formulario);
          });
        }
      } else {
        let texto =
          "*Desculpe, no momento esta opção não esta disponível.*" + this.ctrl;

        let formulario = {
          contato: contato[0].telefone,
          mensagem: texto
        };
        this.enviarMsg(formulario);
        setTimeout(() => {
          this.onOpcaoChat(contato, "0");
        }, 5000);
      }
      // fim
    });
  }
  notificarAtendente(mensagem, contato) {
    let dados = {
      status: "Nova",
      acesso: contato[0].acesso,
      bloqueado: contato[0].bloqueado,
      coordenadas: contato[0].coordenadas,
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      data_nascimento: "",
      invalida: contato[0].invalida,
      localizacao: contato[0].localizacao,
      nivel: contato[0].nivel,
      nome: contato[0].nome,
      telefone: contato[0].telefone,
      tipo: contato[0].tipo,
      key_pergunta: contato[0].key_pergunta,
      protocolo: contato[0].protocolo,
      key_master: contato[0].key_master,
      key_child: contato[0].key_child,
      uid: contato[0].uid,
      opcao: contato[0].opcao,
      menu: contato[0].menu,
      type: mensagem.type,
      value: mensagem.body,
      time: Date.now(),
      messageNumber: "0001"
    };
    let chatLive = {
      status: "Nova",
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      nome: contato[0].nome,
      telefone: contato[0].telefone,
      tipo: contato[0].tipo,
      protocolo: contato[0].protocolo,
      opcao: contato[0].opcao,
      menu: contato[0].menu,
      type: mensagem.type,
      time: Date.now(),
      hora_notificacao: '',
      tempo_espera: '',
      tempo_atendimento: '',
      tempo_ocioso: '',
      key_usuario: '',
      nome_usuario: '',
      grau_satisfacao: '',
      notifica_usuario: mensagem.notifica_usuario
    };
    contato[0].chatSetor = true;
    this.atualizaContato(contato[0]);
    this.genProvider.onSaveDocKey(
      "dados/" + this.parametros.path + "/chatSetor",
      contato[0].protocolo,
      dados
    );
    this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/chatLive", chatLive, "chatLive");
  }
  onMenosNivel(contato) {
    let nivel = contato[0].nivel - 1;
    if (nivel <= -1) {
      nivel = 0;
    }
    if (nivel == 0) {
      this.filtroNivel(this.menus, 0).then(menu => {
        this.onMontaMenu(menu).then(res => {
          let menu = res;
          let formulario = {
            contato: contato[0].telefone,
            mensagem: this.escolha_opcao + menu + this.ctrl + this.rodape,
            caption: this.escolha_opcao + menu + this.ctrl + this.rodape
          };
          this.enviarMsg(formulario);
          (contato[0].data_hora = new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm"
          )),
            (contato[0].time = Date.now());
          contato[0].nivel = 0;
          contato[0].key_master = 0;
          contato[0].key_child = 0;
          contato[0].uid = 0;
          contato[0].key_pergunta = this.key_pergunta;
          contato[0].opcao = 0;
          contato[0].tipo = "Pergunta";
          this.atualizaContato(contato[0]);
          //     this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/contato', contato.telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, Erro.')});
        });
      });
    } else {
      //  console.log ('nivel > 0')
      this.filtroUid(this.menus, contato[0].key_child.toString()).then(res => {
        let uid = JSON.parse(JSON.stringify(res));
        let filtro =
          nivel.toString() +
          contato[0].key_master.toString() +
          uid[0].key_child.toString();
        this.filtroMenu(this.menus, filtro).then(res => {
          let menu = JSON.parse(JSON.stringify(res));
          this.onMontaMenu(menu).then(res => {
            let menu_opc = res;
            let formulario = {
              contato: contato[0].telefone,
              mensagem:
                this.escolha_opcao + menu_opc + this.ctrl + this.msg_navegacao,
              caption:
                this.escolha_opcao + menu_opc + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
            (contato[0].data_hora = new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            )),
              (contato[0].acesso = 2);
            contato[0].time = Date.now();
            contato[0].nivel = nivel;
            contato[0].key_master = menu[0].key_master;
            contato[0].key_child = menu[0].key_child;
            contato[0].uid = menu[0].uid;
            contato[0].key_pergunta = this.key_pergunta;
            contato[0].tipo = menu[0].tipo;
            this.atualizaContato(contato[0]);
            // this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/contato', contato[0].telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, erro ao salvar dados.')});
          });
        });
      });
    }
    // atualiza
  }
  onContato(mensagem) {
    if (mensagem.body) {
      if (mensagem.body.substring(0, 5).toLowerCase() == "*sair" || mensagem.body.substring(0, 4).toLowerCase() == "sair") {
        this.pesquisaContato(mensagem.author).then(res => {
          let contato = JSON.parse(JSON.stringify(res));
          if (contato.length > 0) {
            this.onFinalizaAtendimento(contato);
          }
        });
      }
      else {
        this.validaContato(mensagem).then(res => {
          let contato = JSON.parse(JSON.stringify(res));
          if (contato[0].acesso == -1) {
            this.atualizaContato(contato[0])
            this.onStartAtendimento(contato, mensagem)
          } else if (contato[0].tipo == "Pesquisa") {
            let pesquisa = mensagem.body;
            let nao_achou =
              "Sua pesquisa - " +
              mensagem.body +
              " - não encontrou nenhum produto ou serviço correspondente." +
              this.ctrl;
            nao_achou += "Sugestões:" + this.ctrl;
            nao_achou +=
              "Certifique-se de que todas as palavras estejam escritas corretamente." +
              this.ctrl;
            nao_achou += "Tente palavras-chave diferentes." + this.ctrl;
            nao_achou += "Tente palavras-chave mais genéricas." + this.ctrl;
            let formulario = {
              contato: contato[0].telefone,
              mensagem: "Aguarde! Estamos processando sua pesquisa."
            };
            this.enviarMsg(formulario);

            let dataAtual = new Date();
            let inicio = dataAtual.setDate(dataAtual.getDate());
            let url = "dados/" + this.parametros.path + "/cliente";

            let subscription = this.genProvider
              .onGetFilterOrder(url, "nome", "publicar_ate", inicio, ">=")
              .subscribe(
                data => {
                  let tmp = JSON.parse(JSON.stringify(data));
                  subscription.unsubscribe();

                  let clientes = tmp.map(res => {
                    res.busca = res.nome;
                    res.busca = res.categoria_nome;
                    res.busca += res.cnpj_cpf;
                    res.busca += res.telefone;
                    res.busca += res.localizacao;
                    if (res.complemento) {
                      res.busca += res.complemento;
                    }
                    res.busca += res.texto;
                    return res;
                  });
                  let i = 0;
                  setTimeout(() => {
                    if (clientes.length > 0) {
                      this.filtroPesquisa(clientes, pesquisa).then(res => {
                        let data = JSON.parse(JSON.stringify(res));
                        if (data.length > 0) {
                          this.onMontaMenuPublicidade(data).then(res => {
                            let formulario = {
                              contato: contato[0].telefone,
                              mensagem: res + this.ctrl + this.msg_navegacao
                            };
                            this.enviarMsg(formulario);
                          });

                          contato[0].time = Date.now();
                          //               contato[0].nivel = 1;
                          //              contato[0].key_master = menu[0].key_master;
                          //              contato[0].key_child = menu[0].key_child;
                          //             contato[0].uid = menu[0].uid;
                          //             contato[0].key_pergunta = this.key_pergunta;
                          //            contato[0].opcao = opcao
                          contato[0].tipo = "Pesquisa_Existe";
                          this.atualizaContato(contato[0]);
                        } else {
                          let formulario = {
                            contato: contato[0].telefone,
                            mensagem: nao_achou
                          };
                          this.enviarMsg(formulario);
                          setTimeout(() => {
                            this.onOpcaoChat(contato, "0");
                          }, 5000);
                        }
                      });
                    } else {
                      let formulario = {
                        contato: contato[0].telefone,
                        mensagem: nao_achou
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaoChat(contato, "0");
                      }, 5000);
                    }
                  }, 5000);
                },
                err => console.log(err)
              );

            // fim
          } else if (contato[0].tipo == "API") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              //     setTimeout(() => {
              //       this.onOpcaoChat(contato, "-1");
              //    }, 5000);
              this.onFinalizaAtendimento(contato);
            } else {
              let headers = new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "method": "post"
              });
              let options = {
                headers: headers
              }
              let dados = mensagem.body.replace(/\D/g, "");
              let url = contato[0].api.replace("{{data}}", dados);
              if (dados != "") {
                this.http.post(url, dados, options).subscribe(
                  data => {
                    //       this.http.get(url, options).map(data => {
                    // let result = data.json()
                    let result = JSON.parse(JSON.stringify(data));
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: JSON.stringify(result)
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaoChat(contato, "-1");
                    }, 5000);
                  },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      contato: "559180333070",
                      mensagem: "Ocorreu um erro na solicitação"
                    };
                    let formulario2 = {
                      contato: contato[0].telefone,
                      mensagem:
                        "No momento este serviço esta indisponível, por favor tente mais tarde."
                    };
                    this.enviarMsg(formulario);
                    this.enviarMsg(formulario2);
                    //   setTimeout(() => {
                    //     this.onOpcaoChat(contato, "-1");
                    //   }, 5000);
                    this.onFinalizaAtendimento(contato);
                  }
                );
              }
            }
          } else if (contato[0].tipo == "Consulta") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaoChat(contato, "-1");
              }, 5000);
              this.onFinalizaAtendimento(contato);
            } else {
              let protocolo = mensagem.body.replace(/\D/g, "");
              let dados = {
                protocolo: this.parametros.instancia,
                token: contato[0].token,
                iddenuncia: protocolo
              };
              let url = contato[0].api.replace("{{data}}", dados);
              if (protocolo != "") {
                let headers = new HttpHeaders({
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "method": "post"
                });
                let options = {
                  headers: headers
                }
                this.http.post(url, dados, options).subscribe(
                  res => {
                    //   console.log("Resultado ", result);
                    let data = JSON.parse(JSON.stringify(res));
                    //     console.log (data)
                    if (data._body == "null") {
                      let formulario = {
                        contato: contato[0].telefone,
                        mensagem:
                          "Número de protocolo *" +
                          protocolo +
                          "* não existe!" +
                          this.ctrl +
                          "Digite e envie o protocolo." +
                          this.ctrl +
                          this.cancelar
                      };
                      this.enviarMsg(formulario);
                      //                 setTimeout(() => {
                      //                   this.onOpcaoChat(contato, "-1");
                      //                }, 5000);
                    } else {
                      let body = JSON.parse(data._body);
                      let msg = "Protocolo: " + body["iddenuncia"] + this.ctrl;
                      msg +=
                        "Última Atualização: " + body["dt_update"] + this.ctrl;
                      msg += "Situação: " + body["situacao"] + this.ctrl + this.ctrl;
                      msg += '*Esta é uma mensagem automática, não responda* 😉'
                      let formulario = {
                        contato: contato[0].telefone,
                        mensagem: msg
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaoChat(contato, "-1");
                        this.excluirContato(contato[0].telefone)
                      }, 2000);
                    }
                  },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: "Ocorreu um erro na solicitação"
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaoChat(contato, "-1");
                      this.excluirContato(contato[0].telefone)
                    }, 2000);
                  }
                );
              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Envie um número de protocolo válido."
                };
                this.enviarMsg(formulario);
              }
            }
          } else if (contato[0].tipo == "Consulta Denuncia") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaoChat(contato, "-1");
              }, 5000);
            } else {
              let protocolo = mensagem.body.replace(/\D/g, "");
              if (protocolo != "") {
                this.genProvider.onGetfilter('dados/' + this.parametros.path + '/denuncia', 'protocolo', protocolo).subscribe(res => {
                  let data = JSON.parse(JSON.stringify(res));
                  if (data.length == 0) {
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem:
                        "Número de protocolo *" +
                        protocolo +
                        "* não existe!" +
                        this.ctrl +
                        "Digite e envie o protocolo." +
                        this.ctrl +
                        this.cancelar
                    };
                    this.enviarMsg(formulario);
                  } else {
                    let msg = '*Status da sua denúncia*' + this.ctrl
                    msg += 'Protocolo: ' + data[0].protocolo + this.ctrl
                    msg += 'Última Atualização: ' + data[0].data_status + this.ctrl
                    msg += 'Situação: ' + data[0].status_denuncia + this.ctrl + this.ctrl
                    msg += '*Esta é uma mensagem automática, não responda* 😉'
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: msg
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaoChat(contato, "-1");
                      this.excluirContato(contato[0].telefone)
                    }, 2000);
                  }
                },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: "Ocorreu um erro na solicitação"
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaoChat(contato, "-1");
                      this.excluirContato(contato[0].telefone)
                    }, 2000);
                  }
                );
              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Envie um número de protocolo válido."
                };
                this.enviarMsg(formulario);
              }
            }
          } else if (contato[0].tipo == "Mensagem") {
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "mensagem",
                "mensagem_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (opc == "1" || opc == "sim" || opc == "sin") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem", dados_msg);
              this.onFinalizaAtendimento(contato);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao") {
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: false,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "mensagem_body",
                  dados_body
                );
                this.pesquisaMensagens(contato[0].protocolo).then(data => {
                  let res = JSON.parse(JSON.stringify(data));
                  if (res.length == 0) {
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/mensagem",
                      dados.protocolo,
                      dados
                    );
                    this.mensagens.push(dados);
                  }
                });
                this.mensagens_body.push(dados_body);
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_recebida
                };
                this.enviarMsg(msg);
              }
            }
          } else if (contato[0].tipo == "Mensagem Ticket") {
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "ticket",
                "ticket_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (opc == "1" || opc == "sim" || opc == "sin") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "ticket", dados_msg);
              this.onFinalizaAtendimento(contato);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao") {
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: false,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "ticket_body",
                  dados_body
                );
                this.pesquisaMensagens(contato[0].protocolo).then(data => {
                  let res = JSON.parse(JSON.stringify(data));
                  if (res.length == 0) {
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/ticket",
                      dados.protocolo,
                      dados
                    );
                    this.mensagens.push(dados);
                  }
                });
                this.mensagens_body.push(dados_body);
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_recebida
                };
                this.enviarMsg(msg);
              }
            }
          } else if (contato[0].tipo == "Mensagem Chat") {
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "chatSetor",
                "chatSetor_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (opc == "1" || opc == "sim" || opc == "sin") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "chatSetor", dados_msg);
              let mensagem = {
                author: contato[0].telefone,
                body: "Mensagem Recebida (AgentBot)",
                date: contato[0].time,
                senderName: contato[0].nome,
                type: "chat",
                notifica_usuario: false
              }
              this.notificarAtendente(mensagem, contato);
              this.onFinalizaAtendimento(contato);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao") {
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: false,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "chatSetor_body",
                  dados_body
                );
                this.pesquisaMensagens(contato[0].protocolo).then(data => {
                  let res = JSON.parse(JSON.stringify(data));
                  if (res.length == 0) {
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/chatSetor",
                      dados.protocolo,
                      dados
                    );
                    this.mensagens.push(dados);
                  }
                });
                this.mensagens_body.push(dados_body);
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_recebida
                };
                this.enviarMsg(msg);
              }
            }
          } else if (contato[0].tipo == "Setor") {
            let opc = mensagem.body.replace(" ", "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              this.onCancelaMsg(
                contato[0].protocolo,
                "chatSetor",
                "chatSetor_body"
              );
              this.onOpcaoChat(contato, "0");
            } else {
              let dados = {};
              if (contato[0].chatSetor == false) {
                dados = {
                  status: "Nova",
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  messageNumber: mensagem.messageNumber
                };
                contato[0].chatSetor = true;
                this.atualizaContato(contato[0]);
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/chatSetor",
                  contato[0].protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
              } else {
                dados = {
                  key: contato[0].protocolo,
                  status: "Nova Mensagem",
                  data_envio: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  finalizada: "nao",
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "chatSetor",
                  dados
                );
              }
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "chatSetor_body",
                dados_body
              );
            }
          } else if (contato[0].tipo == "Localizacao") {
            //       let opc = mensagem.body.replace(/\D/g, '').trim();
            let opc = mensagem.body.replace(" ", "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "mensagem",
                "mensagem_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/mensagem",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "mensagem_body",
                  dados_body
                );
                this.mensagens_body.push(dados_body);
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_mensagem
                };
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "mensagem",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now()
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };

              this.pesquisaMensagens(contato[0].protocolo).then(data => {
                let res = JSON.parse(JSON.stringify(data));
                if (res.length == 0) {
                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/mensagem",
                    dados.protocolo,
                    dados
                  );
                  this.mensagens.push(dados);
                }
              });
              this.mensagens_body.push(dados_body);
              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Saude") {
            let opcao = this.ctrl + this.ctrl + "*Digite e envie apenas _SIM_ ou _NÃO_*"
            let msg_negativa = "Entendemos. Anotado! 📝" + this.ctrl
            msg_negativa += "Pelas informações que você nos passou, neste momento NÃO há uma situação de emergência/risco para o novo coronavírus (COVID-19)." + this.ctrl
            msg_negativa += "Nos próximos dias, caso algum novo sintoma apareça, nos procure novamente." + this.ctrl
            msg_negativa += "Enquanto isso você pode contribuir com cuidados como:" + this.ctrl
            msg_negativa += "✅ Lavar as mãos frequentemente com água e sabão, ou higienizar com álcool em gel 70%;" + this.ctrl
            msg_negativa += "✅ Cubra sempre a boca e nariz com seu antebraço ou com um lenço de papel ao tossir e/ou espirrar (nunca com as mãos) e jogue no lixo após o uso;" + this.ctrl
            msg_negativa += "✅ Evite tocar nos olhos, nariz e boca com as mãos não lavadas;" + this.ctrl
            msg_negativa += "✅ Evite locais com aglomeração de pessoas;" + this.ctrl
            msg_negativa += "✅ Não compartilhe objetos de uso pessoal." + this.ctrl

            let opc = mensagem.body.replace(" ", "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "saude",
                "saude_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/saude",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "saude_body",
                  dados_body
                );
                this.mensagens_body.push(dados_body);
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: "Hoje ou nos últimos 7 dias, você ou a pessoa para quem está consultando apresentou FEBRE maior que 37,8 grau?" + opcao
                };
                contato[0].saude++
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (contato[0].saude == 1) {
              if (mensagem.body.substring(0, 1).toLowerCase() != "s") {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: msg_negativa
                };
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);

              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "E um ou mais destes sintomas?" + this.ctrl +
                    "🔹 Tosse" + this.ctrl +
                    "🔹 Dor de garganta" + this.ctrl +
                    "🔹 Dificuldade para respirar" + this.ctrl +
                    "Apresentou hoje ou nos últimos 7 dias?" + opcao
                };
                contato[0].saude++
                this.atualizaContato(contato[0]);
                this.enviarMsg(formulario);
              }
            } else if (contato[0].saude == 2) {
              if (mensagem.body.substring(0, 1).toLowerCase() != "s") {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: msg_negativa
                };
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);

              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Entendi. Qual a sua idade ou a idade para quem você está consultando?"
                };
                contato[0].saude++
                this.atualizaContato(contato[0]);
                this.enviarMsg(formulario);
              }
            } else if (contato[0].saude == 3) {
              let formulario = {
                contato: contato[0].telefone,
                mensagem: "Entendemos. Anotado! 📝" + this.ctrl +
                  "🔹 Dificuldade para respirar e/ou falta de ar quando está em repouso ou ao fazer pequenos esforços?" + this.ctrl +
                  "🔹 Sensação de cansaço muito forte?" + this.ctrl +
                  "🔹 Sensação de desmaio?" + this.ctrl +
                  "Apresentou hoje ou nos últimos 7 dias?" + opcao
              };
              contato[0].saude++
              this.atualizaContato(contato[0]);
              this.enviarMsg(formulario);
            } else if (contato[0].saude == 4) {
              if (mensagem.body.substring(0, 1).toLowerCase() != "s") {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Agora vou perguntar sobre algumas condições de saúde. Se você se encaixar em uma ou mais das situações abaixo, responda SIM para 👇" + this.ctrl +
                    "❤ Doenças cardíacas: hipertensão arterial (pressão alta), coronariopatias (doença dos vasos do coração), valvulopatias (doença de válvulas do coração), IAM prévio (infarto anterior)?" + this.ctrl +
                    "👃 Doenças respiratórias: asma e outras pneumopatias (doenças do pulmão)? Ou está com tuberculose ativa?" + this.ctrl +
                    "🧠 Doenças neurológicas: disfunção congênita, lesões medulares, epilepsia, paralisia cerebral, síndrome de Down, derrame (AVC/AVE) ou doenças neuromusculares?" + opcao
                };
                contato[0].saude = 200
                this.atualizaContato(contato[0]);
                this.enviarMsg(formulario);
              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Certo. Anotado! 📝" + this.ctrl +
                    "Pelas informações que você nos deu, é provável que esta situação se enquadre como casos suspeito de doença pelo coronavírus (COVID-19)." + this.ctrl +
                    "Por essa suspeita, o próximo passo é você falar com o Serviço de Atendimento da SESPA ou procure uma unidade de pronto atendimento UPA para realizar um primeiro atendimento."
                };
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);
              }
            } else if (contato[0].saude == 200) {
              if (mensagem.body.substring(0, 1).toLowerCase() != "s") {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Certo, entendemos!" + this.ctrl +
                    "Pelas informações que você nos deu, os sintomas indicam que você pode estar com uma infecção respiratória, ou seja, sem sinais de gravidade." + this.ctrl +
                    "E o melhor a se fazer neste caso é praticar o ISOLAMENTO DOMICILIAR por 14 dias. Mas sabemos que em alguns casos pode ser difícil conseguir ficar em casa..." + this.ctrl +
                    "Para cumprir esse isolamento."
                };
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);

              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "E alguma destas? 👇" + this.ctrl +
                    "🔹 Diabetes" + this.ctrl +
                    "🔹 Câncer" + this.ctrl +
                    "🔹 Doenças do fígado" + this.ctrl +
                    "🔹 Doença dos rins" + this.ctrl +
                    "🔹 Problemas de saúde que causam imunidade baixa (HIV, transplantes e outros)." + opcao
                }
                contato[0].saude++
                this.atualizaContato(contato[0]);
                this.enviarMsg(formulario);
              }
            } else if (contato[0].saude == 201) {
              if (mensagem.body.substring(0, 1).toLowerCase() != "s") {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "E você:" + this.ctrl +
                    "🤰 É gestante ou está na fase de puerpério até 2 semanas após parto ou teve aborto neste período?" + this.ctrl +
                    "🔹 Ou tem obesidade grave (Índice de Massa Corporal - IMC maior do que 40)?" + opcao
                };
                contato[0].saude++
                this.atualizaContato(contato[0]);
                this.enviarMsg(formulario);
              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Certo, entendemos!" + this.ctrl +
                    "Pelas informações que você nos deu, os sintomas indicam que você pode estar com uma infecção respiratória, ou seja, sem sinais de gravidade." + this.ctrl +
                    "E o melhor a se fazer neste caso é praticar o ISOLAMENTO DOMICILIAR por 14 dias. Mas sabemos que em alguns casos pode ser difícil conseguir ficar em casa..." + this.ctrl +
                    "Para cumprir esse isolamento."
                }
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);

              }
            } else if (contato[0].saude == 202) {
              if (mensagem.body.substring(0, 1).toLowerCase() != "s") {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Certo, entendemos!" + this.ctrl +
                    "Pelas informações que você nos deu, os sintomas indicam que você pode estar com uma infecção respiratória, ou seja, sem sinais de gravidade." + this.ctrl +
                    "E o melhor a se fazer neste caso é praticar o ISOLAMENTO DOMICILIAR por 14 dias. Mas sabemos que em alguns casos pode ser difícil conseguir ficar em casa..." + this.ctrl +
                    "Para cumprir esse isolamento."
                };
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);
              } else {
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem: "Certo, entendemos!" + this.ctrl +
                    "Pelas informações que você nos deu, os sintomas indicam que você pode estar com uma infecção respiratória, ou seja, sem sinais de gravidade." + this.ctrl +
                    "E o melhor a se fazer neste caso é praticar o ISOLAMENTO DOMICILIAR por 14 dias. Mas sabemos que em alguns casos pode ser difícil conseguir ficar em casa..." + this.ctrl +
                    "Para cumprir esse isolamento."
                }
                this.enviarMsg(formulario);
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 2000);

              }
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "saude",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now()
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };

              this.pesquisaMensagens(contato[0].protocolo).then(data => {
                let res = JSON.parse(JSON.stringify(data));
                if (res.length == 0) {
                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/saude",
                    dados.protocolo,
                    dados
                  );
                  this.mensagens.push(dados);
                }
              });
              this.mensagens_body.push(dados_body);
              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Sugestao") {
            //       let opc = mensagem.body.replace(/\D/g, '').trim();
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "mensagem",
                "mensagem_body"
              );

              this.enviarMsg(formulario);
              //              setTimeout(() => {
              this.onOpcaoChat(contato, "0");
              //            }, 5000);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  sugestao: true,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  sugestao: contato[0].sugestao,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/mensagem",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "mensagem_body",
                  dados_body
                );

                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_mensagem
                };
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                contato[0].sugestao = false;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (opc == "#" && contato[0].sugestao) {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "mensagem",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else if (opc == "#" && !contato[0].sugestao) {
              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_sugestao
              };
              this.enviarMsg(msg);
              contato[0].localizacao = true;
              contato[0].sugestao = true;
              this.atualizaContato(contato[0]);
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                sugestao: true,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                messageNumber: mensagem.messageNumber,
                time: Date.now()
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                messageNumber: mensagem.messageNumber,
                telefone: contato[0].telefone,
                sugestao: contato[0].sugestao,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/mensagem",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "mensagem_body",
                dados_body
              );

              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);

              //        let formulario = {
              //          contato: contato[0].telefone,
              //          mensagem: this.mensagem.replace('{{2}}',contato[0].nome)
              //       };
              //      this.enviarMsg(formulario);
              //      setTimeout(() => {
              //           this.onOpcaoChat(contato, '-1');
              //       }, 5000);
            }
          } else if (contato[0].tipo == "Denuncia") {
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
              this.excluirDenuncia(contato[0].protocolo);
            } else if (opc == "1" || opc == "sim" || opc == "sin") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova",
                status_denuncia: 'Recebida',
                finalizada: "nao"
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "denuncia", dados_msg);
              this.mensagemCount++
              this.onFinalizaAtendimento(contato);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao") {
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: "Continue com sua denúncia."
                };
                this.enviarMsg(msg);
              } else {
                let dados = {
                  status: "Enviando...",
                  status_denuncia: 'Recebida',
                  acesso: contato[0].acesso,
                  bloqueado: false,
                  coordenadas: contato[0].coordenadas,
                  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "denuncia_body",
                  dados_body
                );
                this.denuncia_body.push(dados_body);
                this.pesquisaDenuncia(contato[0].protocolo).then(data => {
                  let res = JSON.parse(JSON.stringify(data));
                  if (res.length == 0) {
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/denuncia",
                      dados.protocolo,
                      dados
                    );
                    this.denuncia.push(dados);
                  }
                });

                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_recebida
                };
                this.enviarMsg(msg);
              }
            }
          } else if (contato[0].tipo == "Ouvidoria") {
            //       let opc = mensagem.body.replace(/\D/g, '').trim();
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "ouvidoria",
                "ouvidoria_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
            } else if (opc == "1" || opc == "sim" || opc == "sin") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "ouvidoria",
                dados_msg
              );

              this.onFinalizaAtendimento(contato);
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now()
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                messageNumber: mensagem.messageNumber,
                fromMe: false,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/ouvidoria",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "ouvidoria_body",
                dados_body
              );
              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida + this.ctrl + "*1* - ✅ Sim, já finalizei minha mensagem."
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Midia") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaoChat(contato, "-1");
              }, 5000);
            } else if (mensagem.type != "chat" && !this.midiaMensagem) {
              this.midiaMensagem = mensagem.body;
              this.type_midia = mensagem.type;
              let texto = this.msg_midia
              this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  *_0_* para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (mensagem.type != "chat" && this.midiaMensagem) {
              let texto = this.msg_midia
              this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  *_0_* para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (mensagem.type == "chat" && !this.midiaMensagem) {
              let texto =
                "{{2}} você precisa enviar um arquivo válido conforme solicitado *(VÍDEO, ÁUDIO, IMAGEM, PDF, DOCX...)*." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else {
              let formulario = {
                contato: contato[0].telefone,
                mensagem: this.mensagem.replace("{{2}}", contato[0].nome)
              };
              //   this.enviarMsg(formulario);
              let dados = {
                status: "Nova",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now()
              };
              let dados_body_midia = {
                protocolo: contato[0].protocolo,
                messageNumber: mensagem.messageNumber,
                fromMe: false,
                telefone: contato[0].telefone,
                type: this.type_midia,
                value: this.midiaMensagem,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem_body", dados_body_midia);
              let dados_body_texto = {
                protocolo: contato[0].protocolo,
                messageNumber: mensagem.messageNumber,
                fromMe: false,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem_body", dados_body_texto);
              this.midiaMensagem = "";
              this.type_midia = "";
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem", dados);
              this.onFinalizaAtendimento(contato);
            }
          } else if (contato[0].tipo == "Anunciar") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if (opc == "0") {
              let texto = "{{2}}, seu anuncio foi cancelado.";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaoChat(contato, "0");
              }, 5000);
            } else if (mensagem.type == "image" && !this.imagemAnuncio) {
              this.imagemAnuncio = mensagem.body;
              let texto =
                "{{2}}, agora você precisa escrever o texto do seu anuncio." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (mensagem.type == "image" && this.imagemAnuncio) {
              let texto =
                "{{2}} você precisa enviar agora o texto do seu anuncio." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (mensagem.type == "chat" && !this.imagemAnuncio) {
              let texto =
                "{{2}} você precisa enviar uma imagem/foto do seu produto." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else {
              let formulario = {
                contato: contato[0].telefone,
                mensagem: this.anunciar.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              let dados = {
                status: "Nova",
                token: mensagem.token,
                menu: contato[0].menu,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                type: mensagem.type,
                messageNumber: mensagem.messageNumber,
                value: mensagem.body,
                imagem: this.imagemAnuncio,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.imagemAnuncio = "";
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "classificado",
                dados
              );
              setTimeout(() => {
                this.onOpcaoChat(contato, "0");
              }, 5000);
            }
          } else if (contato[0].tipo == "Atendimento") {
            let opcao = mensagem.body.replace(/\D/g, "").trim();
            if (opcao == "0") {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaoChat(contato, "-1");
              }, 5000);
            } else {
              var time = new Date();
              var date = new Date(
                time.getTime() - this.time_resposta * 60 * 1000
              );
              //   console.log (contato[0].time , Date.parse(date.toString()))
              if (contato[0].time < Date.parse(date.toString())) {
                console.log(
                  "tempo de resposta exedido, inicia o menu principal"
                );
                let formulario = {
                  contato: contato[0].telefone,
                  mensagem:
                    "Atenção, você esta há mais de " +
                    this.time_resposta +
                    " minutos de inatividade, você será redirecionado para o início do atendimento. Obrigado."
                };
                //   this.enviarMsg(formulario);
                this.onStartAtendimento(contato, mensagem);
              } else if (opcao == "0" && contato[0].nivel < 200) {
                this.onOpcaoChat(contato, "-1");
              } else if (contato[0].nivel == 200) {
                let dados = {
                  //    status: 'Espera',
                  key: contato[0].protocolo,
                  menu: contato[0].menu,
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  type: mensagem.type || "chat",
                  value: "Enviou uma mensagem...",
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type || "chat",
                  value: mensagem.body,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "atendimento_body",
                  dados_body
                );
                //      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'atendimento', dados)
              } else {
                this.filtroOpcao(this.departamento, parseInt(opcao)).then(
                  res => {
                    let menu = JSON.parse(JSON.stringify(res));
                    if (menu.length > 0) {
                      let dataAtual = new Date();
                      let expira = dataAtual.setDate(dataAtual.getHours() + 1);
                      let dados = {
                        status: "Nova",
                        protocolo: contato[0].protocolo,
                        messageNumber: mensagem.messageNumber,
                        finalizada: "nao",
                        menu: menu[0].nome,
                        nome: contato[0].nome,
                        telefone: contato[0].telefone,
                        type: mensagem.type,
                        value: "Aguardando atendimento...",
                        time: expira,
                        data_hora: new DatePipe("pt-BR").transform(
                          Date.now(),
                          "d, MMMM yyyy - HH:mm"
                        )
                      };
                      this.genProvider.onSaveDocKey(
                        "dados/" + this.parametros.path + "/atendimento",
                        dados.protocolo,
                        dados
                      ); // atualiza o registro com a mesma chave
                      let formulario = {
                        contato: contato[0].telefone,
                        mensagem: this.atendimento.replace(
                          "{{2}}",
                          contato[0].nome
                        )
                      };
                      this.enviarMsg(formulario);
                      contato[0].nivel = 200;
                      contato[0].menu = menu[0].nome;
                      this.atualizaContato(contato[0]);
                    } else {
                      let mensagem = this.pergunta.opcao_invalida_principal.replace(
                        "{{2}}",
                        contato[0].nome
                      );
                      if (contato[0].nivel > 0) {
                        mensagem = this.pergunta.opcao_invalida.replace(
                          "{{2}}",
                          contato[0].nome
                        );
                      }
                      if (this.mensagem_full.body.substring(0, 4) == "http") {
                        mensagem = this.pergunta.opcao_invalida_outros.replace(
                          "{{2}}",
                          contato[0].nome
                        );
                      }

                      let formulario = {};
                      if (this.opcao_invalida_midia) {
                        formulario = {
                          contato: contato[0].telefone,
                          caption:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: this.opcao_invalida_midia
                        };
                        this.enviarMsg(formulario);
                        formulario = {
                          contato: contato[0].telefone,
                          mensagem:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao
                        };
                        this.enviarMsg(formulario);
                      } else {
                        let formulario = {
                          contato: contato[0].telefone,
                          mensagem:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao
                        };
                        this.enviarMsg(formulario);
                      }
                    }
                  }
                );
              }
            }
          } else if (contato[0].tipo == "Denuncia Localizacao") {
            let opc = mensagem.body.replace(" ", "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              //              setTimeout(() => {
              this.onOpcaoChat(contato, "0");
              //            }, 5000);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  messageNumber: mensagem.messageNumber,
                  coordenadas: mensagem.body,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: res,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  uid: contato[0].uid,
                  opcao: contato[0].opcao,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };

                let dados_body = {
                  protocolo: contato[0].protocolo,
                  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/denuncia",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "denuncia_body",
                  dados_body
                );

                let msg = {
                  contato: contato[0].telefone,
                  mensagem: this.msg_denuncia
                };
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir com a sua denúncia." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.enviarMsg(formulario);
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                countNatureza: contato[0].countNatureza,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                natureza: contato[0].natureza
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                messageNumber: mensagem.messageNumber,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/denuncia",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia_body",
                dados_body
              );

              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Denuncia Natureza_old") {
            let opc = mensagem.body.replace(" ", "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              //              setTimeout(() => {
              this.onOpcaoChat(contato, "0");
              //            }, 5000);
            } else if (contato[0].countNatureza == -2) {
              let opcao = mensagem.body.substring(0, 1).toLowerCase();
              if (opcao == "s") {
                let msg = {
                  contato: contato[0].telefone,
                  mensagem:
                    "Agora você já pode continuar com a sua denúncia, você pode enviar vídeos, audios, localização e textos."
                };
                this.enviarMsg(msg);
                contato[0].countNatureza = -1;
                this.atualizaContato(contato[0]);
              } else {
                let msg = {
                  contato: contato[0].telefone,
                  mensagem: "Digite novamente o tipo da denúncia."
                };
                this.enviarMsg(msg);
                contato[0].countNatureza = 0;
                this.atualizaContato(contato[0]);
              }
            } else if (contato[0].countNatureza >= 0) {
              this.pesquisaPerguntaChatbot(
                mensagem.body,
                this.natureza,
                0
              ).then(res => {
                let result = JSON.parse(JSON.stringify(res));
                if (result.length > 0) {
                  let dados = {
                    status: "Enviando...",
                    acesso: contato[0].acesso,
                    bloqueado: contato[0].bloqueado,
                    coordenadas: contato[0].coordenadas,
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    data_nascimento: "",
                    invalida: contato[0].invalida,
                    localizacao: contato[0].localizacao,
                    nivel: contato[0].nivel,
                    nome: contato[0].nome,
                    telefone: contato[0].telefone,
                    tipo: contato[0].tipo,
                    key_pergunta: contato[0].key_pergunta,
                    protocolo: contato[0].protocolo,
                    key_master: contato[0].key_master,
                    key_child: contato[0].key_child,
                    uid: contato[0].uid,
                    opcao: contato[0].opcao,
                    menu: contato[0].menu,
                    countNatureza: contato[0].countNatureza,
                    type: mensagem.type,
                    value: mensagem.body,
                    time: Date.now(),
                    natureza: result[0].nome
                  };

                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/denuncia",
                    dados.protocolo,
                    dados
                  ); // atualiza o registro com a mesma chave
                  let msg = {
                    contato: contato[0].telefone,
                    mensagem:
                      result[0].resposta +
                      this.ctrl +
                      this.ctrl +
                      "*Para confirmar o tipo de denúncia digite apenas _S_ para SIM ou _N_ digitar outra.*"
                  };
                  this.enviarMsg(msg);
                  contato[0].natureza = result[0].nome;
                  contato[0].countNatureza = -2;
                  this.atualizaContato(contato[0]);
                } else {
                  if (contato[0].countNatureza == 3) {
                    let dados = {
                      status: "Enviando...",
                      acesso: contato[0].acesso,
                      bloqueado: contato[0].bloqueado,
                      coordenadas: contato[0].coordenadas,
                      data_hora: new DatePipe("pt-BR").transform(
                        Date.now(),
                        "d, MMMM yyyy - HH:mm"
                      ),
                      data_nascimento: "",
                      invalida: contato[0].invalida,
                      localizacao: contato[0].localizacao,
                      nivel: contato[0].nivel,
                      nome: contato[0].nome,
                      telefone: contato[0].telefone,
                      tipo: contato[0].tipo,
                      key_pergunta: contato[0].key_pergunta,
                      protocolo: contato[0].protocolo,
                      key_master: contato[0].key_master,
                      key_child: contato[0].key_child,
                      uid: contato[0].uid,
                      opcao: contato[0].opcao,
                      menu: contato[0].menu,
                      countNatureza: contato[0].countNatureza,
                      type: mensagem.type,
                      value: mensagem.body,
                      time: Date.now(),
                      natureza: "OUTRO"
                    };
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/denuncia",
                      dados.protocolo,
                      dados
                    ); // atualiza o registro com a mesma chave
                    let msg = {
                      contato: contato[0].telefone,
                      mensagem: this.msg_padrao_denuncia
                    };
                    this.enviarMsg(msg);
                    contato[0].natureza = "OUTRO";
                    contato[0].countNatureza = -1;
                    this.atualizaContato(contato[0]);
                  } else {
                    contato[0].countNatureza = contato[0].countNatureza + 1;
                    let texto =
                      "ATENÇÃO, você precisa primeiro informar qual tipo de delito vc quer denunciar." +
                      this.ctrl +
                      this.ctrl +
                      "*A qualquer momento digite  0⃣ para cancelar!*";
                    if (contato[0].countNatureza == 1) {
                      texto = this.invalida01_padrao_denuncia;
                    } else if (contato[0].countNatureza == 2) {
                      texto = this.invalida02_padrao_denuncia;
                    } else if (contato[0].countNatureza == 3) {
                      texto = this.invalida03_padrao_denuncia;
                    }
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: texto.replace("{{2}}", contato[0].nome)
                    };
                    this.enviarMsg(formulario);
                    this.atualizaContato(contato[0]);
                  }
                }
              });
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                countNatureza: contato[0].countNatureza,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                natureza: contato[0].natureza
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/denuncia",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia_body",
                dados_body
              );

              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Denuncia Natureza") {
            let opc = mensagem.body.replace(" ", "").trim();
            if (opc == "0") {
              let texto = this.cancela_mensagem;
              let formulario = {
                contato: contato[0].telefone,
                mensagem: texto.replace("{{2}}", contato[0].nome)
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaoChat(contato, "0");
            } else if (contato[0].countNatureza >= 0) {
              this.pesquisaPerguntaChatbot(
                mensagem.body,
                this.natureza,
                0
              ).then(res => {
                let result = JSON.parse(JSON.stringify(res));
                if (result.length > 0) {
                  let dados = {
                    status: "Enviando...",
                    acesso: contato[0].acesso,
                    bloqueado: contato[0].bloqueado,
                    coordenadas: contato[0].coordenadas,
                    messageNumber: mensagem.messageNumber,
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    data_nascimento: "",
                    invalida: contato[0].invalida,
                    localizacao: contato[0].localizacao,
                    nivel: contato[0].nivel,
                    nome: contato[0].nome,
                    telefone: contato[0].telefone,
                    tipo: contato[0].tipo,
                    key_pergunta: contato[0].key_pergunta,
                    protocolo: contato[0].protocolo,
                    key_master: contato[0].key_master,
                    key_child: contato[0].key_child,
                    uid: contato[0].uid,
                    opcao: contato[0].opcao,
                    menu: contato[0].menu,
                    countNatureza: contato[0].countNatureza,
                    type: mensagem.type,
                    value: mensagem.body,
                    time: Date.now(),
                    natureza: result[0].nome
                  };

                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/denuncia",
                    dados.protocolo,
                    dados
                  ); // atualiza o registro com a mesma chave
                  let msg = {
                    contato: contato[0].telefone,
                    mensagem:
                      result[0].resposta +
                      this.ctrl +
                      this.ctrl +
                      "Para cancelar esta denúncia é so digitar e enviar *_0_* (Zero)"
                  };
                  this.enviarMsg(msg);
                  contato[0].natureza = result[0].nome;
                  contato[0].countNatureza = -1;
                  this.atualizaContato(contato[0]);
                } else {
                  if (contato[0].countNatureza == 3) {
                    let dados = {
                      status: "Enviando...",
                      acesso: contato[0].acesso,
                      bloqueado: contato[0].bloqueado,
                      coordenadas: contato[0].coordenadas,
                      messageNumber: mensagem.messageNumber,
                      data_hora: new DatePipe("pt-BR").transform(
                        Date.now(),
                        "d, MMMM yyyy - HH:mm"
                      ),
                      data_nascimento: "",
                      invalida: contato[0].invalida,
                      localizacao: contato[0].localizacao,
                      nivel: contato[0].nivel,
                      nome: contato[0].nome,
                      telefone: contato[0].telefone,
                      tipo: contato[0].tipo,
                      key_pergunta: contato[0].key_pergunta,
                      protocolo: contato[0].protocolo,
                      key_master: contato[0].key_master,
                      key_child: contato[0].key_child,
                      uid: contato[0].uid,
                      opcao: contato[0].opcao,
                      menu: contato[0].menu,
                      countNatureza: contato[0].countNatureza,
                      type: mensagem.type,
                      value: mensagem.body,
                      time: Date.now(),
                      natureza: "OUTRO"
                    };
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/denuncia",
                      dados.protocolo,
                      dados
                    ); // atualiza o registro com a mesma chave
                    let msg = {
                      contato: contato[0].telefone,
                      mensagem: this.msg_padrao_denuncia
                    };
                    this.enviarMsg(msg);
                    contato[0].natureza = "OUTRO";
                    contato[0].countNatureza = -1;
                    this.atualizaContato(contato[0]);
                  } else {
                    contato[0].countNatureza = contato[0].countNatureza + 1;
                    let texto = "";
                    if (contato[0].countNatureza == 1) {
                      texto = this.invalida01_padrao_denuncia;
                    } else if (contato[0].countNatureza == 2) {
                      texto = this.invalida02_padrao_denuncia;
                    } else if (contato[0].countNatureza == 3) {
                      texto = this.invalida03_padrao_denuncia;
                    }
                    let formulario = {
                      contato: contato[0].telefone,
                      mensagem: texto.replace("{{2}}", contato[0].nome)
                    };
                    this.enviarMsg(formulario);
                    this.atualizaContato(contato[0]);
                  }
                }
              });
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Nova"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                uid: contato[0].uid,
                opcao: contato[0].opcao,
                menu: contato[0].menu,
                countNatureza: contato[0].countNatureza,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                natureza: contato[0].natureza
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                messageNumber: mensagem.messageNumber,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/denuncia",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia_body",
                dados_body
              );

              let msg = {
                contato: contato[0].telefone,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "whatscall") {
            if (contato[0].nivel == 200) {
              let whatscall = {
                telefone: contato[0].telefone,
                nome: contato[0].nome,
                value: mensagem.body,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                status: "Espera",
                type: mensagem.type || "chat",
                fromMe: false,
                time: Date.now()
              };
              let dados_whats = {
                key: contato[0].telefone,
                finalizada: "nao",
                status: "Respondeu...",
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "primeiro_atendimento",
                dados_whats
              );
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "whatscall",
                whatscall
              );
            } else {
              let whatscall = {
                telefone: contato[0].telefone,
                nome: contato[0].nome,
                value: mensagem.body,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                status: "Espera",
                type: mensagem.type || "chat",
                fromMe: false,
                time: Date.now()
              };
              let dados_whats = {
                key: contato[0].telefone,
                finalizada: "nao",
                status: "Respondeu...",
                value: mensagem.body,
                time: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "primeiro_atendimento",
                dados_whats
              );
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "whatscall",
                whatscall
              );
              let formulario = {
                contato: contato[0].telefone,
                mensagem: this.atendimento.replace("{{2}}", contato[0].nome)
              };
              //     this.enviarMsg(formulario);
              contato[0].nivel = 200;
              this.atualizaContato(contato[0]);
            }
          } else if (contato[0].status != "Bloqueado") {
            if (contato[0].acesso == 1) {
              let url = "dados/" + this.parametros.path + "/contato";

              (contato[0].data_hora = new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              )),
                (contato[0].acesso = 2);
              contato[0].nome = mensagem.body;
              contato[0].time = Date.now();
              //                      this.genProvider.onSaveDocKey(url, contato[0].telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, Erro.',e)});
              contato[0].nivel = 0;
              contato[0].key_pergunta = this.key_pergunta;
              contato[0].tipo = "Pergunta";
              this.genProvider
                .onSaveDocKey(url, contato[0].telefone, contato[0])
                .then(t => { })
                .catch(e => {
                  console.log("Atenção, Erro.", e);
                });
              if (contato[0].status == "Bloqueado") {
                console.log("Contato bloqueado");
              } else {
                // this.onStartAtendimento(contato);
              }
            } else {
              if (contato[0].status == "Bloqueado") {
                console.log("Contato bloqueado");
              } else {
                this.onChatStart(mensagem, contato);
              }
            }
          } else {
            console.log("Usuario Boqueado ", contato[0].telefone);
          }
        });
      }
    }

  }
  onContatoEnquete(contato, key) {
    return new Promise(resolve => {
      this.genProvider
        .onGetFilterOrder(
          "dados/" + this.parametros.path + "/enquete_voto",
          "key_enquete",
          "telefone",
          contato
        )
        .subscribe(
          data => {
            let res = JSON.parse(JSON.stringify(data));
            let tmp = res.filter(obj => {
              return obj.key_enquete == key;
            });
            resolve(tmp);
          },
          err => console.log(err)
        );
    });
  }
  onMontaMenu(menu) {
    let mensagem = "";
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        mensagem +=
          this.ctrl +
          "*" +
          menu[index].numero +
          "* - " +
          menu[index].emoji +
          " " +
          menu[index].texto;
        //         mensagem += '*'+menu[index].numero + '* - ' + menu[index].texto +this.ctrl;
        //      mensagem +=`[ *${menu[index].numero}* ] ${menu[index].texto}`;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuAtendimento() {
    let menu = this.departamento;
    let mensagem = "";
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        mensagem +=
          this.ctrl +
          "*" +
          menu[index].numero +
          "* - " +
          menu[index].emoji +
          " " +
          menu[index].nome;
        //     mensagem += '*'+menu[index].numero + '* - ' + menu[index].nome +this.ctrl;
        //      mensagem +=`[ *${menu[index].numero}* ] ${menu[index].texto}`;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  filtroMenuEnquete(opc) {
    return new Promise(resolve => {
      let tmp = this.menu_enquete.filter(obj => {
        return obj.numero == opc;
      });
      resolve(tmp);
    });
  }
  filtroMenuEnqueteEncerrada(opc) {
    return new Promise(resolve => {
      let tmp = this.menu_enquete_encerrada.filter(obj => {
        return obj.numero == opc;
      });
      resolve(tmp);
    });
  }
  filtroMenuEnqueteOpcao(opc) {
    return new Promise(resolve => {
      let tmp = this.menuEnqueteOpcao.filter(obj => {
        return obj.numero == opc;
      });
      resolve(tmp);
    });
  }
  pesquisaPerguntaChatbot(chave, file, nivel) {
    //  var RegExp = /\b[^A-Za-zÀ-ú][^A-Za-zÀ-ú]+,?\s[^A-Za-zÀ-ú][^A-Za-zÀ-ú]{2,19}\b/ig;
    var RegExp = /[^A-Za-zÀ-ú]/gi;
    let pesquisa = chave.replace(RegExp, " ");
    var array_pergunta = pesquisa.split(/\s* \s*/);
    let chatbot = file.filter(obj => {
      return obj.pergunta;
    });
    return new Promise(resolve => {
      for (let i = 0; i < array_pergunta.length; i++) {
        let pergunta = array_pergunta[i].trim();
        let res = [];
        if (pergunta.length >= 3) {
          // var array_chatbot = pesquisa.split(/\s* \s*/);
          res = chatbot.filter(obj => {
            if (
              obj.pergunta
                .toLocaleLowerCase()
                .indexOf(pergunta.toLowerCase()) >= 0
            ) {
              return true;
            }
            return false;
          });
        }
        if (res.length > 0) {
          i = array_pergunta.length + 1;
          resolve(res);
          //  return true;
        }
        if (i + 1 >= array_pergunta.length) {
          //   console.log (res)
          resolve(false);
          //    return false;
        }
      }
    });
  }
  pesquisaPergunta(menus, chave) {
    var RegExp = /[^A-Za-zÀ-ú]/gi;
    let pesquisa = chave.replace(RegExp, " ");
    var array_pergunta = pesquisa.split(/\s* \s*/);
    let menu = menus.filter(obj => {
      return obj.pergunta;
    });
    return new Promise(resolve => {
      for (let i = 0; i < array_pergunta.length; i++) {
        let pergunta = array_pergunta[i].trim();
        let res = [];
        if (pergunta.length >= 4) {
          res = menu.filter(obj => {
            if (
              obj.pergunta
                .toLocaleLowerCase()
                .indexOf(pergunta.toLowerCase()) >= 0
            ) {
              return true;
            }
            return false;
          });
        }
        if (res.length > 0) {
          i = array_pergunta.length + 1;
          resolve(res);
        }
        if (i + 1 >= array_pergunta.length) {
          resolve(false);
        }
      }
    });
  }
  onMontaMenuEnqueteOpcao(key) {
    let mensagem = "";
    let menu = this.enqueteOpcao.filter(obj => {
      return obj.key_enquete == key;
    });
    this.menuEnqueteOpcao = menu;
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        mensagem +=
          this.ctrl +
          "*" +
          menu[index].numero +
          "* - " +
          menu[index].emoji +
          " " +
          menu[index].texto;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuEnquete() {
    let menu = this.enquete;
    let mensagem = "";
    this.menu_enquete = [];
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        let tmp = {
          numero: index + 1,
          emoji: menu[index].emoji,
          nome: menu[index].titulo,
          midia: menu[index].imagem,
          texto: menu[index].pergunta,
          key_enquete: menu[index].key_enquete,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia,
          key: menu[index].key,
          mostra_texto: menu[index].mostra_texto
          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        let pergunta = "";
        if (menu[index].mostra_texto) {
          pergunta = menu[index].pergunta;
        }
        this.menu_enquete.push(tmp);
        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* ] *" +
          menu[index].emoji +
          " " +
          menu[index].titulo +
          "*" +
          this.ctrl +
          pergunta;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuEnqueteEncerrada() {
    let menu = this.enqueteEncerrada;
    let mensagem = "";
    this.menu_enquete_encerrada = [];
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        let tmp = {
          numero: index + 1,
          emoji: menu[index].emoji,
          nome: menu[index].titulo,
          midia: menu[index].imagem,
          texto: menu[index].pergunta,
          key_enquete: menu[index].key_enquete,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia,
          key: menu[index].key,
          imgChart: menu[index].imgChart,
          votos: menu[index].votos,
          data_encerramento: menu[index].data_encerramento
          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        this.menu_enquete_encerrada.push(tmp);
        //        mensagem += this.ctrl+'*'+(index+1)+ '* ] *' + menu[index].emoji +" "+ menu[index].titulo +'*'+ this.ctrl+ menu[index].pergunta
        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* ] *" +
          menu[index].emoji +
          " " +
          menu[index].titulo +
          "*";
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuPesquisa(pesquisa) {
    let menu = pesquisa;
    let mensagem = "";
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        mensagem +=
          this.ctrl +
          "*" +
          menu[index].numero +
          "* - " +
          menu[index].emoji +
          " " +
          menu[index].texto;
        //         mensagem += '*'+menu[index].numero + '* - ' + menu[index].nome +this.ctrl;
        //      mensagem +=`[ *${menu[index].numero}* ] ${menu[index].texto}`;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuGaleria(dados) {
    let menu = dados;
    let mensagem = "";
    this.galeria = [];
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        let tmp = {
          numero: index + 1,
          titulo: menu[index].titulo,
          midia: menu[index].midia,
          descricao: menu[index].descricao,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia
          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        this.galeria.push(tmp);
        let titulo = "";
        if (
          menu[index].type_midia == "jpg" ||
          menu[index].type_midia == "jpeg" ||
          menu[index].type_midia == "png"
        ) {
          titulo = "🖼 " + menu[index].titulo;
        } else if (menu[index].type_midia == "mp4") {
          titulo = "📹 " + menu[index].titulo;
        } else if (menu[index].type_midia == "ogg") {
          titulo = "🔊 " + menu[index].titulo;
        } else {
          titulo = "📰 " + menu[index].titulo;
        }
        let descricao = menu[index].descricao;
        let data_hora = menu[index].data_hora;

        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* ] *" +
          titulo +
          "*" +
          this.ctrl +
          "_" +
          descricao +
          "_" +
          this.ctrl +
          "_" +
          data_hora +
          "_" +
          this.ctrl;
        if (index + 1 == menu.length) {
          mensagem += this.ctrl + "*Total na Galeria: " + (index + 1) + "*";
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuPublicidade(dados) {
    let menu = dados;
    let mensagem = "";
    this.publicidade = [];
    // console.log (dados)
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        let tmp = {
          numero: index + 1,
          nome: menu[index].nome,
          midia: menu[index].midia,
          texto: menu[index].texto,
          telefone: menu[index].telefone || " ",
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia,
          localizacao: menu[index].localizacao,
          complemento: menu[index].complemento,
          mostra_localizacao: menu[index].mostra_localizacao,
          desconto: menu[index].des_max,
          latitude: menu[index].latitude,
          longitude: menu[index].longitude

          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        if (menu[index].des_max) {
          menu[index].localizacao +=
            this.ctrl + "*Desconto de até " + menu[index].des_max + "%*";
          menu[index].complemento +=
            this.ctrl + "*Desconto de até " + menu[index].des_max + "%*";
        }
        this.publicidade.push(tmp);
        if (menu[index].mostra_localizacao) {
          mensagem +=
            this.ctrl +
            "*" +
            (index + 1) +
            "* ] *" +
            menu[index].nome +
            "*" +
            this.ctrl +
            menu[index].localizacao +
            this.ctrl;
        } else {
          mensagem +=
            this.ctrl +
            "*" +
            (index + 1) +
            "* ] *" +
            menu[index].nome +
            "*" +
            this.ctrl +
            menu[index].complemento +
            this.ctrl;
        }
        if (index + 1 == menu.length) {
          mensagem += this.ctrl + "*Total da Lista: " + (index + 1) + "*";
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuNoticia(dados) {
    let menu = dados;
    let mensagem = "";
    this.noticia = [];
    // console.log (dados)
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        let tmp = {
          numero: index + 1,
          titulo: menu[index].titulo,
          midia: menu[index].midia,
          descricao: menu[index].descricao,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia

          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        this.noticia.push(tmp);
        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* ] *" +
          menu[index].titulo +
          "*" +
          this.ctrl +
          menu[index].data_hora +
          this.ctrl;
        if (index + 1 == menu.length) {
          mensagem += this.ctrl + "*Total de Notícias: " + (index + 1) + "*";
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onStartLog() {
    return new Promise(resolve => {
      this.isLog = !this.isLog;
      resolve(this.isLog);
    });
  }
  onStart() {
    this.onParametro();
    console.log("Aguarde, iniciando o serviço...");
    setTimeout(() => {
      if (!this.isPergunta) {
        alert("Aguarde um momento, tentando carregar dados...");
      } else {
        this.isonLine = !this.isonLine;
        if (this.isonLine) {
          this.isAcesso = 0;
          this.onConfig();
          this.onFinalizaUsuario();
          //     console.log(this.time);
          setTimeout(() => {
            console.log("ChatBot OnLine!!");
            this.onLine();
            this.onLineAbrirdenuncia()
          }, 3000);
        } else {
          this.isAcesso = 0;
          this.contatos = [];
          this.isPergunta = false;
          console.log("ChatBot OffLine!! ", this.contatos);
          this.postSubscription.unsubscribe();
          this.sendSubscription.unsubscribe();
          this.subAbrir.unsubscribe();
        }
      }
    }, 3000);
  }
  onFinalizaUsuario() {
    this.temporizador().subscribe(res => {
      var time = new Date();
      var date = new Date(time.getTime() - this.time_resposta * 60 * 1000);
      let tempo = Date.parse(date.toString());
      let contatos = this.contatos.filter(obj => {
        return obj.time <= tempo;
      });
      for (let i = 0; i < contatos.length; i++) {
        const element = contatos[i];
        if (element.nivel < 200) {
          this.onWebHookMsg(element.protocolo)
          setTimeout(() => {
            this.onFinalizaProcessos(element);
            this.onMsgInatividade(element);
            this.excluirContato(element.telefone);
          }, 5000);
        }
      }
    });
  }
  onMsgInatividade(element) {
    let msg = this.atendimento_final.replace("{{2}}", element.nome);
    msg = msg.replace(
      "Atendimento Finalizado",
      "Seu atendimento foi finalizado por inatividade!"
    );
    this.filtroNivel(this.menus, 0).then(menu => {
      if (this.informaProtocolo) {
        msg = msg + this.ctrl + "*Protocolo :" + element.protocolo + "*";
      } else {
        msg =
          msg +
          this.ctrl +
          this.ctrl +
          new DatePipe("pt-BR").transform(new Date(), "HH:mm:ss");
      }
      let formulario = {
        contato: element.telefone,
        mensagem: msg,
        midia: this.pergunta.midia
      };
      this.enviarMsg(formulario);
    });
  }
  onFinalizaProcessos(dados) {
    let dados_msg = {
      key: dados.protocolo,
      status: "Nova"
    };
    // pesquisar se existe msgens em aberto
    //   let unSubdenuncia = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/denuncia","protocolo",dados.protocolo)
    //     .subscribe(data => { unSubdenuncia.unsubscribe();
    this.pesquisaDenuncia(dados.protocolo).then(
      data => {
        let dados = JSON.parse(JSON.stringify(data));
        //          if (dados.length > 0 && dados[0].status == "Enviando...") {
        if (dados.length > 0) {
          this.genProvider.onSaveObjeto(
            "dados",
            this.parametros.path,
            "denuncia",
            dados_msg
          );
          this.onWebHookMsg(dados[0].protocolo);
        }
      },
      err => console.log(err)
    );

    this.pesquisaMensagens(dados.protocolo).then(
      data => {
        let dados = JSON.parse(JSON.stringify(data));
        if (dados.length > 0 && dados[0].status == "Enviando...") {
          this.genProvider.onSaveObjeto(
            "dados",
            this.parametros.path,
            "mensagem",
            dados_msg
          );
          this.onWebHookMsg(dados[0].protocolo);
        }
      },
      err => console.log(err)
    );

    this.pesquisaOuvidoria(dados.protocolo).then(
      data => {
        let dados = JSON.parse(JSON.stringify(data));
        if (dados.length > 0) {
          this.genProvider.onSaveObjeto(
            "dados",
            this.parametros.path,
            "ouvidoria",
            dados_msg
          );
          this.onWebHookMsg(dados[0].protocolo);
        }
      },
      err => console.log(err)
    );
  }
  temporizador() {
    // console.log('aki')
    return (this.time = new Observable(observer => {
      setInterval(() => {
        //   console.log(new Date().toString())
        observer.next(new Date().toString());
      }, 60000);
    }));
  }
  onAtualizaEnvio(path, key) {
    this.genProvider
      .onUpdateMsgEnviada(path, key)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onAtualizaEntregue(path, key) {
    this.genProvider
      .onUpdateMsgEntregue(path, key)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onAtualizaFalha(path, key) {
    this.genProvider
      .onUpdateMsgFalha(path, key)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onStartCampanha(msg) {
    this.onConfig();
    let data = msg;
    data.status = "Enviando";
    data.data_inicio = new DatePipe("pt-BR").transform(
      Date.now(),
      "d, MMMM yyyy - HH:mm:ss"
    );
    this.genProvider
      .onSaveObjeto("dados", this.parametros.path, "campanha", data)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });

    let path = "dados/" + this.parametros.path + "/campanha";
    var strTmp = this.parametros.saudacao;
    var array_saudacao = strTmp.split(/\s*;\s*/);
    let enviados = 0;
    let i = 0;
    let turno = "";
    this.continua = true;
    let startMsg = this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/campanha/" + msg.key + "/contatos",
        "nome",
        "status_envio",
        "Aguardando"
      )
      .subscribe(dt => {
        startMsg.unsubscribe();
        let dados = JSON.parse(JSON.stringify(dt));
        if (dados.length > 0) {
          this.myTimer = setInterval(() => {
            let now = new Date();
            let horario = true;
            if (now.getHours() >= 0 && now.getHours() < 12) turno = "Bom dia";
            else if (now.getHours() >= 12 && now.getHours() < 18)
              turno = "Boa tarde";
            else turno = "Boa noite";

            if (
              now.getHours() >= parseInt(this.parametros.hora_inicio) &&
              now.getHours() <= parseInt(this.parametros.hora_fim)
            ) {
              horario = true;
            } else {
              horario = false;
            }
            if (i < dados.length && this.continua && horario) {
              enviados++;
              console.log("Enviados ", enviados++, " de ", dados.length);
              let count = array_saudacao.length - 1;
              let sugestao = Math.floor(Math.random() * count); // Escolher um numero ao acaso
              let saudacao = array_saudacao[sugestao];
              let mensagem = msg.mensagem;
              let contato = dados[i].telefone;
              let nome = dados[i].nome || "";
              if (nome) {
                saudacao = saudacao.replace("{{2}}", nome);
                mensagem = mensagem.replace("{{2}}", nome);
              } else {
                saudacao = saudacao.replace("{{2}}", "");
                mensagem = mensagem.replace("{{2}}", "");
              }
              mensagem = mensagem.replace("{{1}}", this.parametros.razao);
              saudacao = saudacao.replace("{{4}}", turno);
              mensagem = mensagem.replace("{{4}}", turno);
              let texto: any;
              if (msg.saudacao) {
                texto = saudacao + this.ctrl + mensagem;
              } else {
                texto = mensagem;
              }

              let caption = "";
              if (msg.caption) {
                caption = texto;
              }
              let telefone = contato;
              let formulario = {
                contato: telefone,
                mensagem: texto,
                midia: msg.midia,
                type_midia: msg.type_midia,
                caption: caption
              };
              this.enviarMsg(formulario, dados[i]);
              let pessoa: any;
              if (nome) {
                pessoa = {
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  acesso: 2,
                  time: 0,
                  nivel: 0,
                  tipo: "Marketing",
                  telefone: telefone,
                  nome: nome,
                  status: "Ativo"
                };
              } else {
                pessoa = {
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  acesso: 0,
                  time: 0,
                  nivel: 0,
                  tipo: "Marketing",
                  telefone: "55" + telefone,
                  status: "Ativo"
                };
              }
              this.genProvider
                .onSaveDocKey(
                  "dados/" + this.parametros.path + "/contato",
                  pessoa.telefone,
                  pessoa
                )
                .then(t => { })
                .catch(e => {
                  console.log("Atenção, erro ao salvar dados.");
                });
              this.onAtualizaEnvio(path, msg.key);
              i++;
            }
            if (enviados >= this.parametros.apos) {
              enviados = 0;
              this.continua = false;
              this.onPause(this.parametros.pausar, msg);
            }

            // final envio
            if (i >= dados.length) {
              clearInterval(this.myTimer); // finaliza loop
              let data = {
                key: msg.key,
                status: "Finalizada",
                data_fim: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm:ss"
                )
              };
              this.genProvider
                .onSaveObjeto("dados", this.parametros.path, "campanha", data)
                .then(t => { })
                .catch(e => {
                  alert(
                    "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
                  );
                  console.log(e);
                });
              //    alert('Lista de Transmissão Finalizada.')
            }
          }, Math.floor(Math.random() * (this.parametros.intervalo_fim * 1000) + this.parametros.intervalo_inicio * 1000));
        } else {
          alert("Não existe lista pendente de envio.");
        }
      });
  }
  onPause(tempo, dados) {
    //  console.log('pausa em ', tempo)
    let data = {
      key: dados.key,
      status: "Pausado"
    };
    this.genProvider
      .onSaveObjeto("dados", this.parametros.path, "campanha", data)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });

    setTimeout(() => {
      this.continua = true;
      //    console.log('continua a excussao')
      let data = {
        key: dados.key,
        status: "Enviando"
      };
      this.genProvider
        .onSaveObjeto("dados", this.parametros.path, "campanha", data)
        .then(t => { })
        .catch(e => {
          alert(
            "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
          );
          console.log(e);
        });
    }, tempo * 60 * 1000);
  }
  onStop(data) {
    clearInterval(this.myTimer);
    data.status = "Parado";
    this.genProvider
      .onSaveObjeto("dados", this.parametros.path, "campanha", data)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onReset() { }
  onStatus(value: string) {
    this.parametros = this.genProvider.parametros;
    let url = "";
    if (value == "status") {
      url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/status?token=" +
        this.parametros.token;
    } else {
      url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/qr_code?token=" +
        this.parametros.token;
    }
    return new Promise(resolve => {
      this.http.get(url).subscribe(
        data => {
          resolve(data);
          //      console.log (data)
        },
        err => {
          if (!err.ok) {
            console.log("o erro ", err);
            resolve(err);
          }
        }
      );
    });
  }
  // tratamento da api whatsappy
  formataTelefone(valor) {
    valor = valor.replace(/\D/g, '');
    if (valor.length <= 11) {
      let fone = "55" + valor;
      return fone;
    } else {
      return valor
    }
  }
  sendAll(msg, tipo) {
    //console.log (msg, tipo)
    let contato = this.formataTelefone(msg.contato); // message

    if (tipo == "vcard") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendVCard?token=" +
        this.parametros.token;
      let data = {
        phone: contato,
        vcard: msg.vcard
      };
      this.http.post(url, data).subscribe(res => {
        console.log("vCard Enviada para ", contato, res);
      });
    }
    if (tipo == "localizacao") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendLocation?token=" +
        this.parametros.token;
      let data = {
        phone: contato,
        lat: msg.latitude,
        lng: msg.longitude,
        address: msg.localizacao
      };
      this.http.post(url, data).subscribe(res => {
        console.log("Localizacao Enviada para ", contato, res.toString());
      });
    }
    if (tipo == "link") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendLink?token=" +
        this.parametros.token;
      let img =
        "data:image/jpeg;base64,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";
      let link = {
        phone: contato,
        body: msg.http,
        previewBase64: msg.imgem64,
        title: msg.titulo,
        description: msg.descricao
      };

      this.http.post(url, link).subscribe(res => {
        console.log("link Enviada para ", contato, res.toString());
      });
    }
    if (tipo == "audio") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendPTT?token=" +
        this.parametros.token;
      let img =
        "data:image/jpeg;base64,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";
      let audio = {
        phone: contato,
        audio: msg.audio
      };

      this.http.post(url, audio).subscribe(res => {
        console.log("audio Enviada para ", contato, res.toString());
      });
    }
  }
  postAPI(url, data) {
    return new Promise(resolve => {
      let result = this.http.post(url, data).subscribe(res => {
        return res;
      });
      resolve(result);
    });
  }
  onStartChat() {
    this.onParametro();
  }
  enviarMsg_old(mensagem, dados?, phone?) {
    let msg = mensagem;
    let data: any;
    if (mensagem.origem == 'chatbot') {
      this.sendChatBot(mensagem)
    } else if (mensagem.origem == 'email') {
      this.sendMail(mensagem)
    } else if (mensagem.origem == 'messenger') {
      this.sendFaceMessage(mensagem)
    } else if (mensagem.origem == 'whatsapp') {
      if (msg.button) {
        let dados = {
          phone: "559180333070",
          title: "Titulo",
          body: "Corpo da mensagem",
          footer: "Rodape",
          buttons: ["1-Sim", "2-Não"]
        }
        this.sendZapButton(dados);
      } else if (msg.midia) {
        this.sendTyping(msg.contato);
        if (msg.caption) {
          this.sendZapMidia(msg, dados, phone);
          data = {
            id: 0,
            fromMe: true,
            telefone: msg.contato,
            type: msg.type_midia,
            midia: msg.midia,
            value: msg.caption,
            date: Date.now(),
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm.ss.SSS"
            ),
            nome: "chatBot",
            //  messageNumber: 0
          };
        } else {
          this.sendZapMidia(msg, dados, phone);
          setTimeout(() => {
            this.sendZapMsg(msg, dados, phone);
          }, 5000);
        }
      } else {
        this.sendZapMsg(msg, dados, phone);
        data = {
          id: 0,
          fromMe: true,
          telefone: msg.contato,
          type: "",
          midia: "",
          value: msg.mensagem,
          date: Date.now(),
          data_hora: new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm.ss.SSS"
          ),
          nome: "chatBot",
          //  messageNumber: 0
        };
      }
    }
  }
  enviarMsg(mensagem, type?: any, dados?, phone?) {
    let msg = mensagem;
    let data: any;
    if (mensagem.origem == 'chatbot') {
      this.sendChatBot(mensagem, type)
    } else if (mensagem.origem == 'messenger') {
      this.sendFaceMessage(mensagem)
    } else if (mensagem.origem == 'whatsapp') {
      this.onSendWaBi(msg)
    }
  }

  sendMail(msg) {
    let comando = {
      comando: "sendEmail",
      contato: msg.contato,
      assunto: msg.assunto,
      mensagem: msg.mensagem.replace(/\n/g, "</br>")
    }
    this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/srvComando', this.parametros.telefone, comando).then(t => { }).catch(e => { })
  }
  sendFaceMessage(msg) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "method": "post"
    });
    let options = {
      headers: headers
    }

    //    this.formataDados(msg.mensagem,"*", "_").then(res=>{
    //      if (res!="*"){
    //  console.log("nao")
    //     }else {
    //      msg.mensagem = null;
    //      msg.caption = null;
    //     }

    let url = 'https://graph.facebook.com/v8.0/me/messages?access_token=' + this.tokenFace;
    let type = "image";
    if (msg.type_midia) {
      if (msg.type_midia == "jpeg" || msg.type_midia == "jpg" || msg.type_midia == "png") {
        type = "image"
      } else if (msg.type_midia == "ogg" || msg.type_midia == "ppt") {
        type = "audio"
      } else if (msg.type_midia == "pdf" || msg.type_midia == "docx") {
        type = "file"
      } else if (msg.type_midia == "mp4") {
        if (msg.type_anexo == "video") {
          type = "video"
        } else {
          type = "audio"
        }
      }
    } else {
      type = "image"
    }
    if (msg.midia) {
      if (msg.caption) {
        let message = {
          recipient: {
            id: msg.contato
          },
          message: {
            attachment: {
              type: type,
              payload: {
                url: msg.midia
              }
            }
          }
        }
        this.http.post(url, message, options).subscribe(res => {
          let message = {
            recipient: {
              id: msg.contato
            },
            message: {
              text: msg.caption || msg.mensagem
            }
          }
          this.http.post(url, message, options).subscribe(res => {
            //  console.log (res)
          })

        })
      } else {
        let message = {
          recipient: {
            id: msg.contato
          },
          message: {
            attachment: {
              type: type,
              payload: {
                url: msg.midia
              }
            },
          }
        }
        this.http.post(url, message, options).subscribe(res => {
          //  console.log (res)
        })
        if (msg.mensagem) {
          setTimeout(() => {
            let message = {
              recipient: {
                id: msg.contato
              },
              message: {
                text: msg.mensagem
              }
            }
            this.http.post(url, message, options).subscribe(res => {
              //  console.log (res)
            })
          }, 0);
        }
      }
    } else {
      //incio
      if (msg.mensagem.length < 1999) {
        let message = {
          recipient: {
            id: msg.contato
          },
          message: {
            text: msg.mensagem
          }
        }
        this.http.post(url, message, options).subscribe(res => {
        })
      } else {
        // quebrar a mesnagem

        this.divideString(msg.mensagem, 1999).then(res => {
          let dados = JSON.parse(JSON.stringify(res))
          //  console.log(dados)
          dados.forEach(element => {
            let message = {
              recipient: {
                id: msg.contato
              },
              message: {
                text: element
              }
            }
            setTimeout(() => {
              this.http.post(url, message, options).subscribe(res => { })
            }, 1000);

          });

        })
      }

      // fim
    }

    //   });
  }
  onEnviaChatServidor(body, url) {
    let data = {
      comando: "saveChat",
      body: body,
      url: url
    }
    this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/srvComando', this.parametros.telefone, data).then(t => {
    }).catch(e => { console.log('Atenção, erro ao enviar chat para o serividor.') });
  }
  sendChatBot(msg, type?) {
    let url = 'dados/' + this.parametros.path + '/dialogChat/' + msg.contato + '/dialogChat_body'
    if (msg.contato.trim() != '55') {
      if (msg.midia) {
        let dados = {
          status: 'Enviada',
          type: msg.type_midia,
          value: msg.midia,
          time: '',
          data_hora: new DatePipe('pt-BR').transform(
            Date.now(),
            'd, MMMM yyyy - HH:mm'
          )
        }
        let data = {
          comando: "saveChat",
          body: dados,
          url: url
        }
        this.onSaveChat(data)
        //    this.genProvider.onSaveObjeto('dados', this.parametros.path + '/dialogChat/' + msg.contato, 'dialogChat_body', dados);
        if (msg.caption) {
          let dados = {
            status: 'Enviada',
            type: 'chat',
            value: msg.caption,
            time: '',
            data_hora: new DatePipe('pt-BR').transform(
              Date.now(),
              'd, MMMM yyyy - HH:mm'
            )
          }
          let data = {
            comando: "saveChat",
            body: dados,
            url: url
          }
          this.onSaveChat(data)
          //   this.genProvider.onSaveObjeto('dados', this.parametros.path + '/dialogChat/' + msg.contato, 'dialogChat_body', dados);
        }
      } else {
        let tipo = 'chat'
        if (type) {
          tipo = type
        }
        let dados = {
          status: 'Enviada',
          type: tipo,
          value: msg.mensagem,
          time: '',
          data_hora: new DatePipe('pt-BR').transform(
            Date.now(),
            'd, MMMM yyyy - HH:mm'
          )
        }
        let data = {
          comando: "saveChat",
          body: dados,
          url: url
        }
        this.onSaveChat(data)

        //   this.genProvider.onSaveObjeto('dados', this.parametros.path + '/dialogChat/' + msg.contato, 'dialogChat_body', dados);
      }
    }
  }
  onSaveChat(data) {
    data.body.time = Date.now()
    let a = new DatePipe("pt-BR").transform(data.body.time, "dd/MM/yyyy - HH:mm:ss");
    console.log(a)
    this.genProvider.onSave(data.url, data.body)
  }
  formataDados(dados, c, c2?) {
    return new Promise(resolve => {
      try {
        let res = dados.replaceAll(c, "");
        if (c2) {
          let res2 = res.replaceAll(c2, "");
          resolve(res2);
        } else {
          resolve(res);
        }
      } catch (e) {
        resolve(c);
      }
      resolve(dados);
    });
  }
  divideString(str, num) {
    return new Promise(resolve => {
      var pedacos = []
      var i = 0

      while (i < str.length) {
        (i % num == 0 ? pedacos.push(str.substring(i, i + num)) : i++)
        i++
      }
      resolve(pedacos)
      /*
      var t=str.split(''), col = [];
      for (let i = 0; i in t; i++) {
        col.push(t[i]);
        if((i+1) % num === 0) {
          col.push('-');
        }
     }

    resolve(col.join('').split('-').filter(e => e != ""));
    */
      //  let pedacos = []
      //  let i = 0
      //  while (i < str.length){
      //    (i % n == 0 ? pedacos.push(str.substring(i, i + n)) : i++)
      //    i++
      //  }
      // let a = str.match(/.{1,1999}/g);
      //  resolve(a)
    });

  }
  sendZapMidia(msg, dados?, phone?) {
    let hora = new DatePipe("pt-BR").transform(
      Date.now(),
      "d, MMMM yyyy - HH:mm:ss.SSS"
    );

    let contato = this.formataTelefone(msg.contato) + "@c.us";
    if (phone) {
      contato = this.formataTelefone(msg.contato);
    }
    let url =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/sendFile?token=" +
      this.parametros.token;
    let urlMsg =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/message?token=" +
      this.parametros.token;
    let filename = "";
    if (msg.type_midia) {
      filename = `file_${new DatePipe("pt-BR").transform(
        new Date(),
        "yyyy-MM-dd-HH:mm:ss.SSS"
      )}.${msg.type_midia}`;
    } else {
      filename = `file_${new DatePipe("pt-BR").transform(
        new Date(),
        "yyyy-MM-dd-HH:mm:ss.SSS"
      )}.jpg`;
    }
    let data = {};
    if (msg.caption && msg.type_midia == "ogg") {
      try {
        let data1 = {};
        let data2 = {};
        if (phone) {
          data1 = {
            phone: contato,
            body: msg.midia,
            filename: filename
          };
          data2 = {
            phone: contato,
            body: msg.caption
          };
        } else {
          data1 = {
            chatId: contato,
            body: msg.midia,
            filename: filename
          };
          data2 = {
            chatId: contato,
            body: msg.caption
          };
        }
        this.http.post(urlMsg, data2).subscribe(res => {
          console.log("texto Enviada para ", contato, hora, res.toString());
          // enviar o texto
          this.http.post(url, data1).subscribe(res => {
            console.log("audio Enviada para ", contato, hora, res.toString());
            if (dados) {
              let path =
                "/dados/" +
                this.parametros.path +
                "/campanha/" +
                dados.key_campanha +
                "/contatos";
              let status_msg: any;
              if (res.toString()) {
                status_msg = "Entregue";
              } else {
                status_msg = "Não Entregue";
              }
              let data = {
                key: dados.telefone,
                status_envio: "Enviado",
                status_msg: status_msg,
                data_envio: new DatePipe("pt-BR").transform(
                  new Date(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider
                .onSaveDocKey(path, dados.telefone, data)
                .then(t => { })
                .catch(e => {
                  console.log("Atenção, erro ao salvar dados.");
                });
            }
          });
          // fim
          if (dados) {
            let path =
              "/dados/" +
              this.parametros.path +
              "/campanha/" +
              dados.key_campanha +
              "/contatos";
            let status_msg: any;
            if (res.toString()) {
              status_msg = "Entregue";
            } else {
              status_msg = "Não Entregue";
            }
            let data = {
              key: dados.telefone,
              status_envio: "Enviado",
              status_msg: status_msg,
              data_envio: new DatePipe("pt-BR").transform(
                new Date(),
                "d, MMMM yyyy - HH:mm:ss.SSS"
              )
            };
            this.genProvider
              .onSaveDocKey(path, dados.telefone, data)
              .then(t => { })
              .catch(e => {
                console.log("Atenção, erro ao salvar dados.");
              });
          }
        });
      } catch (error) {
        console.log(error);
      }
    } else if (msg.caption && msg.type_midia != "ogg") {
      let data = {};
      try {
        if (phone) {
          data = {
            phone: contato,
            body: msg.midia,
            filename: filename,
            caption: msg.caption
          };
        } else {
          data = {
            chatId: contato,
            body: msg.midia,
            filename: filename,
            caption: msg.caption
          };
        }
        this.http.post(url, data).subscribe(res => {
          console.log("Mensagem Enviada para ", contato, hora, res.toString());
          if (dados) {
            let path =
              "/dados/" +
              this.parametros.path +
              "/campanha/" +
              dados.key_campanha +
              "/contatos";
            let status_msg: any;
            if (res.toString()) {
              status_msg = "Entregue";
            } else {
              status_msg = "Não Entregue";
            }
            let data = {
              key: dados.telefone,
              status_envio: "Enviado",
              status_msg: status_msg,
              data_envio: new DatePipe("pt-BR").transform(
                new Date(),
                "d, MMMM yyyy - HH:mm"
              )
            };
            this.genProvider
              .onSaveDocKey(path, dados.telefone, data)
              .then(t => { })
              .catch(e => {
                console.log("Atenção, erro ao salvar dados.");
              });
          }
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        if (phone) {
          data = {
            phone: contato,
            body: msg.midia,
            filename: filename
          };
        } else {
          data = {
            chatId: contato,
            body: msg.midia,
            filename: filename
          };
        }
        this.http.post(url, data).subscribe(res => {
          console.log("Mensagam Enviada para ", contato, hora);
          if (dados) {
            let path =
              "/dados/" +
              this.parametros.path +
              "/campanha/" +
              dados.key_campanha +
              "/contatos";
            let status_msg: any;
            if (res.toString()) {
              status_msg = "Entregue";
            } else {
              status_msg = "Não Entregue";
            }
            let data = {
              key: dados.telefone,
              status_envio: "Enviado",
              status_msg: status_msg,
              data_envio: new DatePipe("pt-BR").transform(
                new Date(),
                "d, MMMM yyyy - HH:mm"
              )
            };
            this.genProvider
              .onSaveDocKey(path, dados.telefone, data)
              .then(t => { })
              .catch(e => {
                console.log("Atenção, erro ao salvar dados.");
              });
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  sendZapMsg(msg, dados?, phone?) {
    if (msg.mensagem) {
      let hora = new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm.ss.SSS"
      );
      let contato = this.formataTelefone(msg.contato) + "@c.us";
      if (phone) {
        contato = this.formataTelefone(msg.contato);
      }
      //  console.log (contato)
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/message?token=" +
        this.parametros.token;
      let data = {};
      if (phone) {
        data = {
          phone: contato, // Receivers phone
          body: msg.mensagem // Message
        };
      } else {
        data = {
          chatId: contato, // Receivers chatId
          body: msg.mensagem // Message
        };
      }
      this.http.post(url, data).subscribe(res => {
        //     console.log("Mensagam Enviada para ", contato, hora);
        if (dados) {
          let path =
            "/dados/" +
            this.parametros.path +
            "/campanha/" +
            dados.key_campanha +
            "/contatos";
          let status_msg: any;
          if (res.toString()) {
            status_msg = "Entregue";
          } else {
            status_msg = "Não Entregue";
          }

          let data = {
            key: dados.telefone,
            status_envio: "Enviado",
            status_msg: status_msg,
            data_envio: new DatePipe("pt-BR").transform(
              new Date(),
              "d, MMMM yyyy - HH:mm"
            )
          };
          this.genProvider
            .onSaveDocKey(path, dados.telefone, data)
            .then(t => { })
            .catch(e => {
              console.log("Atenção, erro ao salvar dados.");
            });
        }
      });
    }
  }
  sendMsg(mensagem, dados?, phone?) {
    let msg = mensagem;
    this.onParametro();
    if (mensagem.contato.length >= 16) {
      this.sendFaceMessage(mensagem)
    } else {
      if (msg.midia) {
        if (msg.caption) {
          this.sendZapMidia(msg, dados, phone);
        } else {
          this.sendZapMidia(msg, dados, phone);
          setTimeout(() => {
            this.sendZapMsg(msg, dados, phone);
          }, 5000);
        }
      } else {
        this.sendZapMsg(msg, dados, phone);
      }
    }
  }
  sendZapButton(dados) {
    console.log(dados)

    let contato = this.formataTelefone(dados.phone) + "@c.us";
    dados.phone = contato
    let url = this.parametros.servidor + "/instance" + this.parametros.instancia + "/sendButtons?token=" +
      this.parametros.token;
    this.http.post(url, dados).subscribe(res => {
      console.log(res)
    });


  }
  sendTyping(phone) {
    let contato = this.formataTelefone(phone) + "@c.us";
    let data = {
      "phone": contato,
      "on": "1",
      "duration": "5"
    }
    let url =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/typing?token=" +
      this.parametros.token;
    this.http.post(url, data).subscribe(res => {

    });

  }
  onWebHookMsg(id) {
    // cabecalho da mensagem
    if (this.parametros.webhookDenuncia) {
      this.pesquisaDenuncia(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaDenuncia_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = [];
                  dados_body.forEach(res => {
                    let temp = {
                      data_hora: res.data_hora,
                      time: res.time,
                      type: res.type,
                      value: res.value
                    };
                    conteudo.push(temp);
                  });
                  let origem: any
                  if (dados[0].telefone.length >= 16) {
                    origem = "Messenger"
                  } else if (dados[0].telefone.length < 11) {
                    origem = "Phone"
                  } else {
                    origem = "Whatsapp"
                  }
                  let msg = {
                    key: dados[0].key,
                    //idDenuncia: dados[0].iddenuncia || null,
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token,
                    protocolo: dados[0].protocolo,
                    data_hora: dados[0].data_hora,
                    time: dados[0].time,
                    status: dados[0].status,
                    content: conteudo,
                    origem: origem,
                    natureza: ''
                  };
                  let telefone = dados[0].telefone;
                  let headers = new HttpHeaders({
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "method": "post"
                  });
                  let options = {
                    headers: headers
                  }
                  this.http.post(this.parametros.webhookUrl, msg, options).subscribe(res => {
                    let data = JSON.parse(JSON.stringify(res));
                    let protocolo = JSON.parse(data._body);
                    let id = null;
                    let erro = null;
                    if (protocolo["iddenuncia"]) {
                      id = protocolo["iddenuncia"];
                    } else {
                      erro = protocolo["error"];
                    }
                    if (id) {
                      let formulario = {
                        contato: telefone,
                        mensagem:
                          "Protocolo da sua denúncia: " +
                          "*" + id + "*" +
                          this.ctrl +
                          this.msg_denuncia_acompanhar + this.ctrl + '*Esta é uma mensagem automática, não responda* 😉'

                      };
                      this.enviarMsg(formulario, null, true);
                    } else {
                      let formulario = {
                        contato: "559180333070",
                        mensagem:
                          "Protocolo :" +
                          id +
                          this.ctrl +
                          "erro protocolo: " +
                          msg.protocolo +
                          this.ctrl +
                          erro
                      };
                      this.enviarMsg(formulario, null, true);
                    }
                  }, err => {
                    console.log(err);
                    let formulario = {
                      contato: "559180333070",
                      mensagem:
                        "Protocolo :" +
                        id +
                        this.ctrl +
                        "erro no envio p/ DD: " +
                        err
                    };
                    this.enviarMsg(formulario, null, true);
                  }
                  );
                }
              },
              err => {
                console.log(err);
                let formulario = {
                  contato: "559180333070",
                  mensagem:
                    "Protocolo :" +
                    id +
                    this.ctrl +
                    "erro firebase p/ DD: " +
                    err
                };
                this.enviarMsg(formulario, null, true);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    // webhook mensagens
    if (this.parametros.webhookMensagem) {
      this.pesquisaMensagens(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaMensagens_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "mensagem",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                let headers = new HttpHeaders({
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "method": "post"
                });
                let options = {
                  headers: headers
                }
                this.http
                  .post(this.parametros.webhookUrl, msg, options)
                  .subscribe(res => {
                    //     console.log (res)
                    //      this.excluirMensagens(dados[0].protocolo);
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }

    if (this.parametros.webhookOuvidoria) {
      this.pesquisaOuvidoria(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaOuvidoria_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "ouvidoria",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                //    console.log (msg)
                let headers = new HttpHeaders({
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "method": "post"
                });
                let options = {
                  headers: headers
                }
                this.http
                  .post(this.parametros.webhookUrl, msg, options)
                  .subscribe(res => {
                    //     console.log (res)
                    //                       this.excluirOuvidoria(id)
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookSetor) {
      this.pesquisaSetor(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaSetor_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "setor",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                //    console.log (msg)
                let headers = new HttpHeaders({
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "method": "post"
                });
                let options = {
                  headers: headers
                }
                this.http
                  .post(this.parametros.webhookUrl, msg, options)
                  .subscribe(res => {
                    //          this.excluirSetor(id)
                    //     console.log (res)
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    // notidicacao agenda denuncias
    if (this.parametros.whatsDenuncia) {
      this.pesquisaDenuncia(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaDenuncia_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsDenuncia",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO DE DENÚNCIA DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 2000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
    // notificacoes agenda mensagens
    if (this.parametros.whatsMensagem) {
      this.pesquisaMensagens(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaMensagens_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsMensagem",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO DE MENSAGEM DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 2000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
    // notificacoes agenda mensagens
    if (this.parametros.whatsOuvidoria) {
      this.pesquisaOuvidoria(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaOuvidoria_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                // enviar mensagens
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsOuvidoria",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO PARA OUVIDORIA DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 1000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                contato: telefone,
                                caption: "Protocolo: " + id,
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
    // notificacoes agenda mensagens
    if (this.parametros.whatsSetor) {
      this.pesquisaSetor(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaSetor_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                // enviar mensagens
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsOuvidoria",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO DE CHAT DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 1000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                contato: telefone,
                                caption: "Protocolo: " + id,
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  onSalvarUsuario(data) {
    data.opcao = '';
    data.uid = '';
    setTimeout(() => {
      delete data["key"];
      this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/contato", data.telefone, data)
        .then(t => {

        })
        .catch(e => {
          console.log(data)
          console.log("Atenção, erro ao salvar dados.");
          let dados = {
            dados: "Erro ao gravar usuario" + this.ctrl + JSON.stringify(data),
            telefone: "559193026224"
          }
          this.enviarMsg(dados);
        });
    }, 1000);
  }
  onContatoOff(data) {
    let dados = {
      telefone: data.telefone,
      protocolo: data.protocolo,
      nome: data.nome,
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      nivel: 0,
      invalida: 0,
      acesso: -1,
      status: "Ativo",
      online: "off",
      tipo: "Pergunta",
      time: Date.now()
    };
    this.onSalvarUsuario(dados);
    this.excluirDenuncia(data.protocolo)
  }
  Encrypt(value) {
    var result = "";
    for (let i = 0; i < value.length; i++) {
      if (i < value.length - 1) {
        result += value.charCodeAt(i) + 10;
        result += "-";
      } else {
        result += value.charCodeAt(i) + 10;
      }
    }
    return result;
  }
  Decrypt(value) {
    var result = "";
    var array = value.split("-");

    for (let i = 0; i < array.length; i++) {
      result += String.fromCharCode(array[i] - 10);
    }
    return result;
  }
  cipher(salt) {
    const textToChars = text => text.split("").map(c => c.charCodeAt(0));
    const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return text =>
      text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("");
  }

  decipher(salt) {
    const textToChars = text => text.split("").map(c => c.charCodeAt(0));
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded =>
      encoded
        .match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join("");
  }
  pesquisaDenuncia(protocolo) {
    return new Promise(resolve => {
      let res = this.denuncia.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaDenuncia_body(protocolo) {
    return new Promise(resolve => {
      let res = this.denuncia_body.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  excluirDenuncia(protocolo) {
    let res = this.denuncia.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.denuncia.indexOf(res[0]);
      this.denuncia.splice(index, 1);
    }
    let res_body = this.denuncia_body.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res_body.length > 0) {
      res_body.forEach(element => {
        const index = this.denuncia_body.indexOf(element);
        this.denuncia_body.splice(index, 1);
      });
    }
    //  console.log (this.denuncia)
    //  console.log (this.denuncia_body)
  }
  pesquisaMensagens(protocolo) {
    return new Promise(resolve => {
      let res = this.mensagens.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaMensagens_body(protocolo) {
    return new Promise(resolve => {
      let res = this.mensagens_body.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  excluirMensagens(protocolo) {
    let res = this.mensagens.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.mensagens.indexOf(res[0]);
      this.mensagens.splice(index, 1);
    }
    let res_body = this.mensagens_body.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res_body.length > 0) {
      res_body.forEach(element => {
        const index = this.mensagens_body.indexOf(element);
        this.mensagens_body.splice(index, 1);
      });
    }
  }
  pesquisaOuvidoria(protocolo) {
    return new Promise(resolve => {
      let res = this.ouvidoria.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaOuvidoria_body(protocolo) {
    return new Promise(resolve => {
      let res = this.ouvidoria_body.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  excluirOuvidoria(protocolo) {
    let res = this.ouvidoria.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.ouvidoria.indexOf(res[0]);
      this.ouvidoria.splice(index, 1);
    }
    let res_body = this.ouvidoria_body.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res_body.length > 0) {
      res_body.forEach(element => {
        const index = this.ouvidoria_body.indexOf(element);
        this.ouvidoria_body.splice(index, 1);
      });
    }
  }
  pesquisaSetor(protocolo) {
    return new Promise(resolve => {
      let res = this.setor.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaSetor_body(protocolo) {
    return new Promise(resolve => {
      let res = this.setor_body.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  excluirSetor(protocolo) {
    let res = this.setor.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.setor.indexOf(res[0]);
      this.setor.splice(index, 1);
    }
    let res_body = this.setor_body.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res_body.length > 0) {
      res_body.forEach(element => {
        const index = this.setor_body.indexOf(element);
        this.setor_body.splice(index, 1);
      });
    }
  }
  msgCount() {
    return (Observable.interval(2000).map(valor => this.mensagemCount));
  }
  usuarioCount() {
    return (Observable.interval(2000).map(valor => this.contatos.length));
  }
  onStatusBot() {
    return (Observable.interval(3600000).map(valor => {
      return {
        usuariosOnLine: this.contatos.length,
        denuncias: this.mensagemCount,
        denunciasAndamento: this.denuncia.length
      }
    }
    ));
  }
  onCountUsuario() {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetAll("dados/" + this.parametros.path + "/contato", "nome")
        .subscribe(data => {
          let usuarios = JSON.parse(JSON.stringify(data));
          unSub.unsubscribe();
          resolve(usuarios.length);
        });
    })
  }
  onBot() {
    /*
    this.onCountUsuario().then(res => {
      let msg1 = "*Plataforma Disque Denúncia.*" + this.ctrl + "Status WhatsApp." + this.ctrl
      msg1 += "Total de Acessos: " + res + this.ctrl;
      msg1 += "Usuários on line: " + this.contatos.length + this.ctrl;
      msg1 += "Total de Denúncias: " + this.mensagemCount + this.ctrl;
      msg1 += "Denúncias em Andamento: " + this.denuncia.length
      let formulario = {
        contato: "559180333070",
        mensagem: msg1
      };
      this.enviarMsg(formulario);
    })
    */
    if (!this.statusBot) {
      this.statusBot = true;
      this.unSubstatus = this.onStatusBot().subscribe(data => {
        //      this.onCountUsuario().then(res => {
        let msg1 = "*Plataforma Disque Denúncia.*" + this.ctrl + "Status WhatsApp." + this.ctrl
        //        msg1 += "Total de Acessos: " + res + this.ctrl;
        msg1 += "Usuários on line: " + this.contatos.length + this.ctrl;
        msg1 += "Total de Denúncias: " + this.mensagemCount + this.ctrl;
        msg1 += "Denúncias em Andamento: " + this.denuncia.length
        let formulario = {
          contato: "559180333070",
          mensagem: msg1
        };
        this.enviarMsg(formulario);
        //       })
      })
    } else {
      this.unSubstatus.unsubscribe();
      this.statusBot = false;
    }
  }
  onGravarPergunta() {
    this.isGravarPergunta = !this.isGravarPergunta;
  }
  onSavePergunta(contato, data) {
    if (this.isGravarPergunta && data.type == "chat") {
      let dados = {
        telefone: contato.telefone,
        protocolo: contato.protocolo,
        nome: contato.nome,
        data_hora: new DatePipe("pt-BR").transform(
          Date.now(),
          "d, MMMM yyyy - HH:mm"
        ),
        invalida: contato.invalida,
        time: Date.now(),
        value: data.body
      }
      //      console.log (dados)
      this.genProvider.onSaveIncrement('dados/' + this.parametros.path + '/logPergunta', dados, 'logPergunta');
    }
  }
  // implementacao dia 25-06-2021
  getDialogs() {
    this.parametros = this.genProvider.parametros;
    let url =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/dialogs?token=" +
      this.parametros.token;
    return new Promise(resolve => {
      this.http.get(url).subscribe(res => {
        resolve(res);
      });
    });
  }
  onChatUpdate() {
    this.getChatUpdate = this.genProvider.onGetfilter("whatsChatUpdate/", "instanceId", this.parametros.instancia).subscribe(data => {
      this.ChatUpdate = JSON.parse(JSON.stringify(data));
    });
  }
  onFinalizaChat(contato) {
    if (!this.mensagem) {
      this.mensagem = "{{2}}, seu atendiento foi finalizado.";
    }
    let formulario = {
      contato: contato[0].telefone,
      mensagem: this.mensagem.replace("{{2}}", contato[0].nome)
    };
    this.enviarMsg(formulario);
    this.onOpcaoChat(contato, "-1");
    setTimeout(() => {
      this.excluirContato(contato[0].telefone);
    }, 5000);
  }
  onUpdateStatus(data, denuncia) {
    let dados = {};
    //    console.log (data)
    //    console.log (denuncia)
    /*
       let temp = this.status.filter(obj => {
         return obj.key == this.formulario.value.status_key;
       });
       */
    dados = {
      key: data.protocolo,
      status_key: data.key_status,
      status_denuncia: data.status,
      status: "Aguardando...",
      data_status: new DatePipe('pt-BR').transform(
        Date.now(),
        'd, MMMM yyyy - HH:mm'
      )
    }

    if (data.notificaUsuario) {
      let msg = '*Status da sua denúncia*' + this.ctrl
      msg += 'Protocolo: ' + data.protocoloDD + this.ctrl
      msg += 'Última Atualização: ' + data.data_hora + this.ctrl
      msg += 'Situação: ' + data.status + this.ctrl + this.ctrl
      msg += '*Esta é uma mensagem automática, não responda* 😉'
      let formulario = {
        contato: denuncia.telefone,
        mensagem: msg
      };
      this.sendMsg(formulario);
    }
    if (data.abreDenuncia) {
      dados = {
        key: data.protocolo,
        status_key: data.key_status,
        status_denuncia: data.status,
        status: "Aguardando...",
        data_status: new DatePipe('pt-BR').transform(
          Date.now(),
          'd, MMMM yyyy - HH:mm'
        )
      }

      let msg = '*Status da sua denúncia*' + this.ctrl
      msg += 'Protocolo: ' + data.protocolo + this.ctrl
      msg += 'Última Atualização: ' + data.data_hora + this.ctrl
      msg += 'Situação: ' + data.status + this.ctrl + this.ctrl
      msg += '*Por favor, complemente a sua denúncia com as informações que estão faltando* 😉' + this.ctrl
      //      msg += 'Avaliação: '+this.formulario.value.avaliacao ||' '
      let formulario = {
        contato: denuncia.telefone,
        mensagem: msg
      };
      this.sendMsg(formulario);
      this.abriDenuncia(data, denuncia);
    }
    this.genProvider.onSaveObjeto('dados', this.parametros.path, 'denuncia', dados)
    console.log("Status Atualizado.")
  }

  public abriDenuncia(data, denuncia) {
    //  let susContato = this.genProvider.onGetfilter('dados/' + this.parametros.path + '/contato', 'telefone', denuncia.telefone).subscribe(res => {
    //    let contato = JSON.parse(JSON.stringify(data));
    //    if (contato.length > 0 ){
    //  console.log (data)
    //  console.log (denuncia)
    let atuContato = {
      acesso: 2,
      bloqueado: denuncia.bloqueado,
      coordenadas: denuncia.coordenadas,
      data_hora: new DatePipe('pt-BR').transform(
        Date.now(),
        'd, MMMM yyyy - HH:mm'
      ),
      data_nascimento: denuncia.data_nascimento,
      invalida: denuncia.invalida,
      localizacao: denuncia.localizacao,
      nivel: denuncia.nivel,
      nome: denuncia.nome,
      status: "Ativo",
      telefone: denuncia.telefone,
      status_denuncia: denuncia.status_denuncia,
      time: Date.now(),
      data: Date(),
      tipo: denuncia.tipo,
      key_pergunta: denuncia.key_pergunta,
      protocolo: denuncia.protocolo,
      key_master: denuncia.key_master,
      key_child: denuncia.key_child,
      uid: denuncia.uid,
      opcao: denuncia.opcao,
      menu: denuncia.menu,
      countNatureza: 0,
      natureza: ''
    }
    this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/abrirdenuncia", this.parametros.instancia, atuContato);
    let dados = {
      status: "Enviada",
      protocolo: denuncia.protocolo,
      nome: denuncia.nome,
      telefone: denuncia.telefone,
      type: "chat",
      value: data.status,
      time: Date.now(),
      data_hora: new DatePipe('pt-BR').transform(
        Date.now(),
        'd, MMMM yyyy - HH:mm'
      )
    }
    this.genProvider.onSaveObjeto('dados', this.parametros.path, 'denuncia_body', dados);
    //  }
    //   susContato.unsubscribe();
    // });
  }
  onGerarCor() {
    let temp: any = Math.random() * 0xFFFFFF
    let a = parseInt(temp)
    let b = a.toString(16)
    let c = '#' + b.padStart(6, '0')
    return c
  }

  onSendWaBi_old(msg: any) {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1"
    });
    let options = {
      headers: headers
    }
    let body = null
    if (msg.midia) {
      if ((msg.type_midia == 'document') || (msg.type_midia == 'pdf') || (msg.type_midia == 'doc') || (msg.type_midia == 'docx') || (msg.type_midia == 'xls') || (msg.type_midia == 'xlsx')) {
        // this.sendTextWaBa("Aguarde, já estamos enviando o documento.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + "/v1/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "document",
            recipient_type: "individual",
            document: {
              link: msg.midia,
              caption: msg.mensagem || 'documento'
            }
          }
        }
      } else if ((msg.type_midia == 'imagem') || (msg.type_midia == 'image') || (msg.type_midia == 'jpg') || (msg.type_midia == 'jpeg') || (msg.type_midia == 'png')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando a imagem.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + "/v1/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "image",
            recipient_type: "individual",
            image: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }
      } else if ((msg.type_midia == 'audio') || (msg.type_midia == 'ogg') || (msg.type_midia == 'ptt') || (msg.type_midia == 'mp3')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando o áudio.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + "/v1/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "audio",
            recipient_type: "individual",
            audio: {
              link: msg.midia
            }
          }
        }
      } else if ((msg.type_midia == 'video') || (msg.type_midia == 'mp3') || (msg.type_midia == 'mp4')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando o vídeo.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + "/v1/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "video",
            recipient_type: "individual",
            video: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }
      } else if ((msg.type_midia == 'location')) {
        body = {
          type: "chat",
          api_url: this.parametros.servidor + "/v1/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "location",
            recipient_type: "individual",
            location: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }

      }
    } else if (msg.header) {
      body = {
        type: "chat",
        api_url: this.parametros.servidor + "/v1/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          type: "interactive",
          interactive: {
            type: "button",
            header: {
              "type": "text",
              "text": msg.header
            },
            body: {
              "text": msg.body
            },
            footer: {
              "text": msg.footer
            },
            action: {
              buttons: [
                {
                  type: "reply",
                  reply: {
                    id: msg.btn1_id,
                    title: msg.btn1_title
                  }
                },
                {
                  type: "reply",
                  reply: {
                    "id": msg.btn2_id,
                    "title": msg.btn2_title
                  }
                }
              ]
            }
          }
        }
      }
    } else {
      body = {
        type: "chat",
        api_url: this.parametros.servidor + "/v1/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          type: "text",
          recipient_type: "individual",
          text: {
            body: msg.mensagem
          }
        }
      }
    }
    let url = this.parametros.url_send
    this.http.post(url, body, options).subscribe(res => {
      console.log(res)
    });

  }
  sendTextWaBa_old(value: string, contato: string) {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1"
    });
    let options = {
      headers: headers
    }
    let body = {
      type: "chat",
      api_url: this.parametros.servidor + "/v1/messages",
      app_id: this.parametros.instancia,
      app_phone: this.parametros.telefone,
      token: "Bearer " + this.parametros.token,
      messages: {
        to: contato,
        type: "text",
        recipient_type: "individual",
        text: {
          body: value
        }
      }
    }
    let url = this.parametros.url_send
    this.http.post(url, body, options).subscribe(res => {
      //   console.log(res)
    });
  }

/*** nova api wharapp */
onSendWaBi(msg: any) {
    let headers = new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1"
      });
      let options = {
        headers: headers
      }
    let body = null
    if (msg.midia) {
      if ((msg.type_midia == 'document') || (msg.type_midia == 'pdf') || (msg.type_midia == 'doc') || (msg.type_midia == 'docx') || (msg.type_midia == 'xls') || (msg.type_midia == 'xlsx')) {
        // this.sendTextWaBa("Aguarde, já estamos enviando o documento.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "document",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            document: {
              link: msg.midia,
              caption: msg.mensagem
            }
          }
        }
      } else if ((msg.type_midia == 'imagem') || (msg.type_midia == 'image') || (msg.type_midia == 'jpg') || (msg.type_midia == 'jpeg') || (msg.type_midia == 'png')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando a imagem.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "image",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            image: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }
      } else if ((msg.type_midia == 'audio') || (msg.type_midia == 'ogg') || (msg.type_midia == 'ptt') || (msg.type_midia == 'mp3')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando o áudio.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "audio",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            audio: {
              link: msg.midia
            }
          }
        }
      } else if ((msg.type_midia == 'video') || (msg.type_midia == 'mp3') || (msg.type_midia == 'mp4')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando o vídeo.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "video",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            video: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }
      } else if ((msg.type_midia == 'location')) {
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "location",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            location: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }

      }
    } else if (msg.list) {
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          messaging_product: "whatsapp",
          type: "interactive",
          interactive: {
            type: "list",
            header: {
              "type": "text",
              "text": msg.header
            },
            body: {
              "text": msg.body
            },
            footer: {
              "text": msg.footer
            },
            action: {
              button: msg.button,
              sections: [
                {
                  title: msg.title,
                  rows: msg.rows,
                }
              ]
            }
          }
        }
      }
    } else if (msg.header) {
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          messaging_product: "whatsapp",
          type: "interactive",
          interactive: {
            type: "button",
            header: {
              "type": "text",
              "text": msg.header
            },
            body: {
              "text": msg.body
            },
            footer: {
              "text": msg.footer
            },
            action: {
              buttons: msg.rows
            }
          }
        }
      }
    } else if (msg.preview_url) {
      let url = msg.preview_url || false;
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          "to": msg.contato,
          "type": "text",
          "recipient_type": "individual",
          "messaging_product": "whatsapp",
          "text": {
            "body": msg.mensagem,
          },
          "preview_url": true
        }
      }
    } else {
      console.log('texto')
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
        app_id: this.parametros.instancia + "/messages",
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          messaging_product: "whatsapp",
          text: {
            body: msg.mensagem
          }
        }
      }
    }

    console.log(body)
    let url = this.parametros.url_send

    this.http.post(url, body, options).subscribe((data: any) => {
      if (data.errors) {
        console.log("aqui")
        let texto = 'Erro Code:' + data.errors[0].code + this.ctrl;
        texto += data.errors[0].title + this.ctrl;
        texto += data.errors[0].details + this.ctrl;
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            recipient_type: "individual",
            messaging_product: "whatsapp",
            text: {
              body: texto,
            }
          }
        }
        this.http.post(url, body, options).subscribe((res: any) => {
          console.log(res)

        });
      }
    });
  }
  sendTextWaBa(value: string, contato: string) {
    let headers = new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1"
      });
      let options = {
        headers: headers
      }
    let body = {
      type: "chat",
      api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/messages",
      app_id: this.parametros.instancia,
      app_phone: this.parametros.telefone,
      token: "Bearer " + this.parametros.token,
      messages: {
        to: contato,
        recipient_type: "individual",
        messaging_product: "whatsapp",
        text: {
          body: value
        }
      }
    }
    let url = this.parametros.url_send
    this.http.post(url, body, options).subscribe((res: any) => {
      console.log(res)
    });
  }
  onDownLoadMidia(data) {
    return new Promise(async (resolve) => {
      let body = {
        type: "download",
        id: data.id,
        api_url: this.parametros.servidor + '/' + this.parametros.token_user +  '/media/' + data.id,
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token
      }
      let xhr = new XMLHttpRequest();
      xhr.responseType = "json"
      xhr.open("POST", 'https://hyperchannelbrasil.com.br/webhook/sendwaba.php', true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      let self = this;
      xhr.responseType = "arraybuffer";
      xhr.onreadystatechange = function (t) {
        if (xhr.readyState == 4) {
          xhr.onload = function (s) {
            const TYPED_ARRAY = new Uint8Array(this.response);
            var base64 = btoa(
              new Uint8Array(TYPED_ARRAY)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            resolve(base64)
          };
        }
      }
      xhr.send(JSON.stringify(body))
    })
  }
/// fim


  onDownLoadMidia_old(id) {
    return new Promise(async (resolve) => {
      let headers = new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1"
      });
      let options = {
        headers: headers
      }
      let body = {
        type: "download",
        id: id,
        api_url: this.parametros.servidor + '/v1/media/' + id,
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token
      }
      console.log(body)
      let url = this.parametros.url_send
      this.http.post(url, body, options).subscribe(res => {
        resolve(res)
      });
    })
  }
  onQrCode(valor) {
    // this.qrValor=valor
    let times = 0;
    return new Promise(function (resolve) {
      var revisa = setInterval(() => {
        let canvas: HTMLCanvasElement = document.querySelector("canvas");
        times++;
        if (canvas) {
          let d = canvas.toDataURL("image/jpeg").toString();
          resolve(d);
          clearInterval(revisa);
        }
      }, 10);
    });
  }
  dateToPT(date) {
    return date.split('-').reverse().join('/');
  }
  dateToMesAno(date) {
    let data = date.split('-').reverse().join('/');
    let dia = data.substring(3, 5);
    let ano = data.substring(6, 10)
    switch (dia) {
      case '01':
        return "JAN / " + ano;
      case '02':
        return "FEV / " + ano;
      case '03':
        return "MAR / " + ano;
      case '04':
        return "ABR / " + ano;
      case '05':
        return "MAI / " + ano;
      case '06':
        return "JUN / " + ano;
      case '07':
        return "JUL / " + ano;
      case '08':
        return "AGO / " + ano;
      case '09':
        return "SET / " + ano;
      case '10':
        return "OUT / " + ano;
      case '11':
        return "NOV / " + ano;
      case '12':
        return "DEZ";

    }
  }
  onIntegracaoTicket(data: any) {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "method": "POST"
    });
    let options = {
      headers: headers
    }
    console.log(data)
    let url = data.urlApi
    if (url) {
      this.pesquisaChat_body(data.protocolo).then(
        data_body => {
          let dados_body = JSON.parse(JSON.stringify(data_body));
          if (dados_body.length > 0) {
            let conteudo = [];
            dados_body.forEach(e => {
              if (e.type == 'chat' || e.type == 'interactive') {
                if (e.value) {
                  //  denuncia = denuncia + e.value + this.ctrl;
                }
              } else {
                let temp = {
                  type: e.type,
                  value: e.value
                };
                conteudo.push(temp);
              }
            });
            let msg = {
              instanceId: this.parametros.telefone,
              token: this.parametros.token_user,
              ticket: data.key,
              key_solicitante : data.key_solicitante,
              nome_solicitante : data.nome_solicitante,
              protocolo_atendimento: data.protocolo,
              tipo_ticket: data.tipo_ticket,
              titulo_ticket: data.titulo_ticket,
              status: "inserir",
              situacao: "registrada",
              status_ticket: "novo",
              data_criacao: data.data_criacao,
              data_hora: data.data_hora,
              time: data.time,
              canal: data.canal,
              lat: data.lat,
              lng: data.lng,
              local: data.local,
              bairro: data.bairro,
              cidade: data.cidade,
              estado: data.estado,
              cep: data.cep,
              texto: data.conteudoTexto,
              html: data.conteudo,
              files: conteudo,
              agente: data.agente,
              key_catalogo: data.key_catalogo,
              nome_catalogo: data.nome_catalogo,
              key_item: data.key_item,
              nome_item: data.item,
              key_subitem: data.key_subitem,
              nome_subitem: data.subitem
            };
            console.log(msg)
            this.http.post(url, msg, options).subscribe(res => {
              console.log(res)
              let data = JSON.parse(JSON.stringify(res));
              console.log(data)
              let temp = {
                key: msg.ticket,
                status_integracao: 'Integrado'
              }
              this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ticket', temp)
            }, err => {
              console.log(err);
              let formulario = {
                origem: 'email',
                contato: "paulospcoelho@gmail.com",
                assunto: "Erro servico DD",
                mensagem:
                  "Protocolo :" +
                  data.protocolo +
                  this.ctrl +
                  "erro no envio p/ DD: " +
                  err
              };
              this.enviarMsg(formulario);
            }
            );

          } else {
            let conteudo = [];
            let msg = {
              instanceId: this.parametros.instancia,
              token: this.parametros.token_user,
              ticket: data.key,
              protocolo_atendimento: data.protocolo,
              key_solicitante : data.key_solicitante,
              nome_solicitante : data.nome_solicitante,
              tipo_ticket: data.tipo_ticket,
              titulo_ticket: data.titulo_ticket,
              status: "inserir",
              situacao: "registrada",
              status_ticket: "novo",
              data_criacao: data.data_criacao,
              data_hora: data.data_hora,
              time: data.time,
              canal: data.canal,
              lat: data.lat,
              lng: data.lng,
              local: data.local,
              bairro: data.bairro,
              cidade: data.cidade,
              estado: data.estado,
              cep: data.cep,
              texto: data.conteudoTexto,
              html: data.conteudo,
              files: conteudo,
              agente: data.agente,
              key_catalogo: data.key_catalogo,
              nome_catalogo: data.nome_catalogo,
              key_item: data.key_item,
              nome_item: data.item,
              key_subitem: data.key_subitem,
              nome_subitem: data.subitem
            };
            console.log(msg)
            this.http.post(url, msg, options).subscribe(res => {
              console.log(res)
              let data = JSON.parse(JSON.stringify(res));
              console.log(data)
              let temp = {
                key: msg.ticket,
                status_integracao: 'Integrado'
              }
              this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ticket', temp)
            }, err => {
              console.log(err);
              let formulario = {
                origem: 'email',
                contato: "paulospcoelho@gmail.com",
                assunto: "Erro servico DD",
                mensagem:
                  "Protocolo :" +
                  data.protocolo +
                  this.ctrl +
                  "erro no envio p/ DD: " +
                  err
              };
              this.enviarMsg(formulario);
            }
            );
          }
        },
        err => {
          console.log(err);
          let formulario = {
            origem: 'email',
            assunto: "Erro servico webhook ticket",
            contato: "paulospcoelho@gmail.com",
            mensagem:
              "Protocolo :" +
              data.protocolo +
              this.ctrl +
              "erro firebase p/ DD: " +
              err
          };
          this.enviarMsg(formulario);
        }
      );
      // fim
    }

  }
  pesquisaTicket(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/ticket", "protocolo", protocolo).subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaChat_body(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetAll("dados/" + this.parametros.path + "/chat/" + protocolo + "/chat_body", "time").subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
}
/*
{
  "instanceId": "558001231234",
  "token": "bWF0cml4d2hhdHNhcGk6V3lCdzZxLnU5cXtKKHxaNVQqS04=",
  "ticket": "20220727.000001.000161",
  "key_solicitante" : "559280333070",
  "nome_solicitante : "Reginaldo Esteves",
  "protocolo_atendimento": "20220726.000001.175501217",
  "tipo_ticket": "Incidente", // "Evento" "Requisição"
  "titulo_ticket": "Chamado central",
  "status": "inserir", // "atualizar" "excluir"
  "situacao": "registrada",
  "status_ticket": "Novo", //"Tramitado"
  "data_criacao": 1658948998091,
  "data_hora": "27, julho 2022 - 15:09",
  "time": 1658948998092,
  "canal": "whatsapp",// "email" "sms" "painel" "menseger" "instagram" "telegram"
  "lat": null,
  "lng": null,
  "local": null,
  "bairro": null,
  "cidade": null,
  "estado": null,
  "cep": null,
  "texto": "TESTE DE SOLICITACAO DE WEBHOOK",
  "html": "<p>TESTE DE SOLICITACAO DE WEBHOOK</p>",
  "files": [
    {
      "type": "png",
      "value": "https://firebasestorage.googleapis.com/v0/b/itnbusiness-618d5.appspot.com/o/chat%2Ffile_2022-07-27-14%3A36%3A06.Capturar.PNG?alt=media&token=0fe2fa97-7962-465c-8733-b5177d2d75df"
    }
  ],
  "agente": "Administrador",
  "key_catalogo": "1",
  "nome_catalogo": "Atendimento",
  "key_item": "59",
  "nome_item": "Chamado central",
  "key_subitem": "2",
  "nome_subitem": "Problema no sistema"
}
*/
